import { Message } from "element-ui";
import {
  ptOnLine,
  userSelect,
  addEntityToDrawing,
  getEntityById,
  addAxisEntityToDrawing,
  getSelectEntity,
  gridLineInsertWith,
  ptIsEqual,
} from "@/rlMxModules/operate/operateApi";
import { get_entity_by_id } from "@/rlMxModules/operate/index";
import * as THREE from "three";
import {
  rlJointData,
  rlGridData,
  rlGridArcData,
  rlAxisData,
  rlAxisArcData,
  rlWallData,
  rlWallHoleData,
  rlColumnData,
  rlRingBeamData,
  rlSlabData,
  rlSlabHoleData,
  rlSubBeamData,
  rlBeamData,
  rlPartitionWallData,
  rlDoorsWindowsData,
  rlUseData,
} from "@/rlMxModules/rlDataClass/index";
import store from "@/store";
import { getArcPoints } from "@/rlMxModules/Opencascad/getModelDrawData.js";
import {
  getEntityData,
  JointIsExist,
  toggleAxisDist,
  highlightEntityArray,
  clearEntityArrayHighlight,
  JointIsOnGrid,
  jointCutGrid,
} from "./operateApi";
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import { updataAxisShowData } from "./operateAxisData";
//弹窗组件
import { VXETable } from "vxe-table";
// 判断删除接口0
import {
  getDelText,
  setDelModule,
  saveDatabaseStore,
  enableSnapCorrection,
  GridIsExist,
  lineInsection,
  lineArcIntersection1,
  arcArcIntersection1,
} from "@/rlMxModules/operate/operateApi.js";
import {
  getInputElement,
  createInputElement,
  setInputElementPosition,
  eraseOtherData,
  setContainerShow,
  setCurrDataObj,
} from "@/rlMxModules/operate/inputElement.js";
import {
  setSketchContainerShow,
  getSketchInputElement,
  eraseSketchOtherData,
} from "@/rlMxModules/operate/sketchInputElement";
import {
  MxCADResbuf,
  MxCADUiPrPoint,
  McDbLine,
  MxCADUtility,
  McGePoint3d,
  MxCpp,
  McCmColor,
  McGeMatrix3d,
  McGeVector3d,
} from "mxcad";
import { getGridAxisData } from "./operateAxisData";
import { fixOrthogonal } from "@/rlMxModules/utils/util";
import CreateSlab from "./createSlab";
import {
  checkContoursIntersection,
  isLinesOverlapping,
} from "@/rlMxModules/operate/GraphicDataCal.js";
import { createConfirmButton, setIds, getIds } from "./createConfirmButton";
import {
  destroyMergeSplitButton,
  createMergeSplitButton,
  setMergeSplitButtonPosition,
} from "@/rlMxModules/operate/beamMergeSplitButton";
import { isParallel } from "@/rlMxModules/operate/structural";
import { isEmpty } from "xe-utils";
// 返回一个取点坐标
// export const select_point = () => {
//   return new Promise((resolve, reject) => {
//     // 实例化取点对象
//     const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
//     // 鼠标第一次点击
//     getPoint.go((status) => {
//       if (status == -1) {
//         Message.closeAll();
//       }
//       if (status != 0) {
//         return;
//       }
//       // 当前鼠标位置
//       let pt = getPoint.value();
//       resolve(pt);
//     });
//   });
// };

export const selectPointDraw = () => {
  return new Promise((resolve, reject) => {
    // 实例化取点对象
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();

    getPoint.setUserDraw((currentPoint, pWorldDraw) => {});
    // 鼠标第一次点击
    getPoint.go((status) => {
      if (status == -1) {
        Message.closeAll();
      }
      if (status != 0) {
        return;
      }
      // 当前鼠标位置
      let pt = getPoint.value();
      resolve(pt);
    });
  });
};

// 选取实体
export const select_entiy_get = () => {
  return new Promise(async (resolve, reject) => {
    const id = await rlAppObj._rlMx.MxFun.selectEnt("提示信息");
    if (!id) return;
    let entiyData = rlAppObj.rlMxDrawObject.getMxEntity(id);
    resolve(entiyData);
  });
};

//选取实体构件
export const select_entiy_model_get = () => {
  return new Promise(async (resolve, reject) => {
    let filter = new MxCADResbuf();
    filter.AddMcDbEntityTypes("LWPOLYLINE");
    let aryId = await rlAppObj.rlMxCpp.MxCADUtility.userSelect(
      "选择构件",
      null
    );

    //

    // const id = await rlAppObj._rlMx.MxFun.selectEnt("提示信息");
    //
    // if (!id) return;
    // let entiyData = rlAppObj.rlMxDrawObject.getMxEntity(id);
    //

    // if (entiyData.ModelType) resolve(entiyData);
    // else return;
  });
};

// 取消连续选择实体
export const makeCancelable = (promise) => {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      (val) => (hasCanceled_ ? reject({ isCanceled: true }) : resolve(val)),
      (error) => (hasCanceled_ ? reject({ isCanceled: true }) : reject(error))
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
};

// 连续选取实体
export const contSelectGet = (callback) => {
  let hasCanceled_ = false;

  const select = async () => {
    if (hasCanceled_) {
      return;
    }
    const id = await rlAppObj._rlMx.MxFun.selectEnt("提示信息");
    let entityData = null;
    if (id) {
      entityData = rlAppObj.rlMxDrawObject.getMxEntity(id);
    }
    if (!hasCanceled_) {
      callback(entityData);
    }
    select();
  };

  const cancelablePromise = {
    promise: select(),
    cancel() {
      hasCanceled_ = true;
    },
  };

  return cancelablePromise;
};

// 实体的删除操作前处理
export const handle_del = (classTypeName, entiy) => {
  if (classTypeName == "rlJoint") {
    rlAppObj.rlMxDatabase.getGroup("rlPointGroup")?.delete(entiy);
  }
  if (classTypeName == "rlAxis") {
    rlAppObj.rlMxDatabase.getGroup("rlLineAxisGroup")?.delete(entiy);
  }
  if (classTypeName == "rlGrid") {
    rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.delete(entiy);
  }
  if (classTypeName == "rlBeamSeg") {
    rlAppObj.rlMxDatabase.getGroup("rlBeamGroup")?.delete(entiy);
  }
  if (classTypeName == "rlColSeg") {
    rlAppObj.rlMxDatabase.getGroup("rlColumnGroup")?.delete(entiy);
  }
  if (classTypeName == "rlWallSeg") {
    rlAppObj.rlMxDatabase.getGroup("rlWallGroup")?.delete(entiy);
  }
  if (classTypeName == "rlSlab") {
    rlAppObj.rlMxDatabase.getGroup("rlSlabGroup")?.delete(entiy);
  }
};

export const delete_ents = (delArray) => {
  return new Promise((resolve, reject) => {
    // 如果要删除的数组为空,直接返回
    if (delArray.length === 0) return;

    const del_fn = async (ids) => {
      if (ids.length > 0) {
        try {
          // var el = document.querySelector(".MD_PG");
          showFullScreenLoading("正在删除数据...");
          // 提交一个全局的操作步骤
          store.commit("globalData/setCanAddRawStep", true);
          let DI = [];
          // 遍历每个要删除的对象,获取其关联的要删除的ID
          let delIds = [];
          for (let i = 0; i < ids.length; i++) {
            const item = ids[i];
            const mcObj = item.getMcDbEntity();
            if (!mcObj) continue;
            const objGuid = mcObj.getxDataString("Guid").val;
            const objClassName = mcObj.getxDataString("classTypeName").val;

            if (!objGuid || !objClassName) {
              continue;
            }

            // 根据GUID和类型名获取实体对象
            const obj = getEntityData({
              Guid: objGuid,
              classTypeName: objClassName,
            });
            if (!obj) continue;

            const idsToDelete = [];
            if (
              objClassName == "rlColSeg" &&
              delArray.includes(3) &&
              obj.Attribute == 1
            ) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            //构造柱
            if (
              objClassName == "rlColSeg" &&
              delArray.includes(26) &&
              obj.Attribute == 2
            ) {
              console.log(obj);

              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            if (
              objClassName === "rlBeamSeg" &&
              obj.Attribute == 1 &&
              delArray.includes(9)
            ) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            if (store.state.globalData.isSketch) {
              if (objClassName === "rlGridC" && delArray.includes(8)) {
                idsToDelete.push(obj);
              }
            } else {
              if (objClassName === "rlGrid" && delArray.includes(8)) {
                idsToDelete.push(obj);
              }
            }
            if (objClassName === "rlWallSeg" && delArray.includes(4)) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            if (objClassName === "rlSlab" && delArray.includes(5)) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            if (objClassName === "rlCantiSlab" && delArray.includes(13)) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            if (
              (objClassName === "rlRingBeamSeg" ||
                (objClassName === "rlBeamSeg" &&
                  obj.m_sectParamData.IsRingBeamSeg == 1)) &&
              delArray.includes(6)
            ) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            if (store.state.globalData.isSketch) {
              if (objClassName === "rlAxisC" && delArray.includes(7)) {
                idsToDelete.push(obj);
              }
            } else {
              if (objClassName === "rlAxis" && delArray.includes(7)) {
                idsToDelete.push(obj);
              }
            }
            if (store.state.globalData.isSketch) {
              if (objClassName === "rlJointC" && delArray.includes(1)) {
                idsToDelete.push(obj);
              }
            } else {
              if (objClassName === "rlJoint" && delArray.includes(1)) {
                idsToDelete.push(obj);
              }
            }
            //墙洞
            if (
              objClassName === "rlWallHole" &&
              obj.doorsWindowsType == 2 &&
              delArray.includes(11)
            ) {
              idsToDelete.push(obj);
            }
            //板洞
            if (objClassName === "rlSlabHole" && delArray.includes(12)) {
              idsToDelete.push(obj);
            }
            //窗
            if (
              objClassName === "rlWallHole" &&
              obj.doorsWindowsType == 0 &&
              delArray.includes(23)
            ) {
              idsToDelete.push(obj);
            }
            //门
            if (
              objClassName === "rlWallHole" &&
              obj.doorsWindowsType == 1 &&
              delArray.includes(22)
            ) {
              idsToDelete.push(obj);
            }
            if (
              (objClassName === "rlSubBeam" ||
                (objClassName === "rlBeamSeg" && obj.Attribute == 2)) &&
              delArray.includes(10)
            ) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            if (
              objClassName === "rlPartitionWallSeg" &&
              delArray.includes(21)
            ) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            // if (objClassName === "rlDoorsWindows") {
            //   if (obj.doorsWindowsType == 1 && delArray.includes(22)) {
            //     idsToDelete.push(obj);
            //     DI.push(obj.Guid);
            //   }
            //   if (obj.doorsWindowsType == 0 && delArray.includes(23)) {
            //     idsToDelete.push(obj);
            //     DI.push(obj.Guid);
            //   }
            // }
            if (objClassName === "rlUse" && delArray.includes(24)) {
              idsToDelete.push(obj);
              DI.push(obj.Guid);
            }
            delIds.push(...idsToDelete);
          }

          //查找所有删除的墙梁关联的网格
          const slabGrids = delIds
            .filter(
              (i) =>
                i.classTypeName == "rlWallSeg" || i.classTypeName == "rlBeamSeg"
            )
            .map((i) => i.m_gridData)
            .flat();

          // console.log("slabGrids", delIds, slabGrids);
          if (slabGrids && slabGrids.length) {
            for (let i = 0; i < slabGrids.length; i++) {
              const item = slabGrids[i];
              if (
                (!item.m_beamId ||
                  (item.m_beamId && DI.includes(item.m_beamId))) &&
                (!item.m_wallId ||
                  (item.m_wallId && DI.includes(item.m_wallId))) &&
                item.m_slabIds &&
                item.m_slabIds.length
              ) {
                DI.push(...item.m_slabIds);
                for (let i = 0; i < item.m_slabIds.length; i++) {
                  const obj = getEntityData({
                    Guid: item.m_slabIds[i],
                    classTypeName: "rlSlab",
                  });
                  if (obj) delIds.push(obj);
                }
              }
            }
          }

          // 将二维数组扁平化并过滤掉空值
          const flatDelIds = delIds.flat().filter(Boolean);
          // 过滤出接口需要的guid
          // var DI = flatDelIds.filter((i) => i.Guid && i.Attribute);

          // 检查要删除的对象是否有检测数据
          const isDetection = DI && DI.length ? await getDelText(DI) : null; //存在数据时才需要调用接口
          // 定义删除函数
          const delFn = async () => {
            // 删除接口
            if (isDetection) {
              await setDelModule(DI);
            }
            //对待删除数据进行归类
            let dataGroup = {};
            let modelDataArray = [];
            for (let i = 0; i < flatDelIds.length; i++) {
              const item = flatDelIds[i];
              if (
                item.classTypeName == "rlGrid" ||
                item.classTypeName == "rlAxis" ||
                item.classTypeName == "rlJoint" ||
                item.classTypeName == "rlGridC" ||
                item.classTypeName == "rlAxisC" ||
                item.classTypeName == "rlJointC"
              ) {
                if (dataGroup[item.classTypeName]) {
                  dataGroup[item.classTypeName].push(flatDelIds[i]);
                } else {
                  dataGroup[item.classTypeName] = [];
                  dataGroup[item.classTypeName].push(flatDelIds[i]);
                }
              } else {
                modelDataArray.push(item);
              }
            }

            //  删除模型
            for (let i = 0; i < modelDataArray.length; i++) {
              const item = modelDataArray[i];
              const entityData = getEntityData({
                classTypeName: item.classTypeName,
                Guid: item.Guid,
              });

              if (entityData) {
                await entityData.erase();
              }
            }

            if (dataGroup["rlGrid"]) {
              for (let i = 0; i < dataGroup["rlGrid"].length; i++) {
                const item = dataGroup["rlGrid"][i];
                const entityData = getEntityData({
                  classTypeName: item.classTypeName,
                  Guid: item.Guid,
                });

                if (entityData) {
                  await entityData.erase();
                }
              }
            }
            if (dataGroup["rlAxis"]) {
              for (let i = 0; i < dataGroup["rlAxis"].length; i++) {
                const item = dataGroup["rlAxis"][i];
                const entityData = getEntityData({
                  classTypeName: item.classTypeName,
                  Guid: item.Guid,
                });

                if (entityData) {
                  await entityData.erase();
                }
              }
            }

            if (dataGroup["rlJoint"]) {
              for (let i = 0; i < dataGroup["rlJoint"].length; i++) {
                const item = dataGroup["rlJoint"][i];
                const entityData = getEntityData({
                  classTypeName: item.classTypeName,
                  Guid: item.Guid,
                });

                if (entityData) {
                  await entityData.erase();
                }
              }
            }

            if (dataGroup["rlGridC"]) {
              for (let i = 0; i < dataGroup["rlGridC"].length; i++) {
                const item = dataGroup["rlGridC"][i];
                const entityData = getEntityData({
                  classTypeName: item.classTypeName,
                  Guid: item.Guid,
                });
                if (entityData) {
                  await entityData.erase();
                }
              }
            }

            if (dataGroup["rlAxisC"]) {
              for (let i = 0; i < dataGroup["rlAxisC"].length; i++) {
                const item = dataGroup["rlAxisC"][i];
                const entityData = getEntityData({
                  classTypeName: item.classTypeName,
                  Guid: item.Guid,
                });
                if (entityData) {
                  await entityData.erase();
                }
              }
            }

            if (dataGroup["rlJointC"]) {
              for (let i = 0; i < dataGroup["rlJointC"].length; i++) {
                const item = dataGroup["rlJointC"][i];
                const entityData = getEntityData({
                  classTypeName: item.classTypeName,
                  Guid: item.Guid,
                });
                if (entityData) {
                  await entityData.erase();
                }
              }
            }

            if (
              dataGroup["rlGrid"] &&
              dataGroup["rlGrid"].length &&
              store.state.displayData.rlLayerDisplay.includes(2)
            ) {
              //更新轴线显示
              toggleAxisDist(false);
              //更新轴线数据
              await updataAxisShowData();
              toggleAxisDist(true);
            }

            rlAppObj.rlMxDrawObject.updateDisplay();
            // 操作完成，隐藏加载状态
            tryHideFullScreenLoading();
          };
          if (isDetection) {
            // 如果有检测数据,则提示用户确认是否删除
            const type = await VXETable.modal.confirm(
              "部分构件检测数据已录,请确认是否删除"
            );
            if (type === "confirm") await delFn();
            else tryHideFullScreenLoading(); // 用户取消时也要隐藏加载
          } else {
            // 如果没有检测数据,直接删除
            await delFn();
          }
          // 保存数据库
          await saveDatabaseStore();
        } catch (error) {
          tryHideFullScreenLoading(); // 删除失败时也要隐藏加载
          console.log("delete_ents error", error);
        }
      } else {
        tryHideFullScreenLoading(); // 如果没有ids, 也隐藏加载
      }
    };
    // 调用用户选择函数,传入删除函数作为回调
    userSelect(del_fn);
  });
};

// 删除单个构件
export const delete_ents_only = async (current_sel_ent) => {
  if (!current_sel_ent.Guid) return;
  // 删除方法
  var delFn = async () => {
    if (
      current_sel_ent.classTypeName == "rlGrid" &&
      (current_sel_ent.m_beamId ||
        current_sel_ent.m_wallId ||
        current_sel_ent.m_partitionWallId)
    ) {
      //提示用户存在构件不能删除
      VXETable.modal.alert("网格上存在构件，不能删除");
      return;
    }

    // 提交一个全局的操作步骤
    store.commit("globalData/setCanAddRawStep", true);

    // 删除视图构件
    await current_sel_ent.erase();
    let inputElement = getInputElement();
    if (inputElement) {
      // inputElement.style.display = "none";
      setContainerShow(false, false, "");
      eraseOtherData();
    }
    let inputSketchElement = getSketchInputElement();
    if (inputSketchElement) {
      // inputElement.style.display = "none";
      setSketchContainerShow(false, false, "");
      eraseSketchOtherData();
    }

    let eraseSlabs = DI.filter((i) => i != current_sel_ent.Guid);
    if (eraseSlabs && eraseSlabs.length) {
      for (let i = 0; i < eraseSlabs.length; i++) {
        const item = getEntityData({
          Guid: eraseSlabs[i],
          classTypeName: "rlSlab",
        });
        if (item) await item.erase();
      }
    }
    await saveDatabaseStore();

    rlAppObj.rlMxDrawObject.updateDisplay();
    // 删除接口--只删除构件的检测数据

    store.commit("globalData/setCurrentSelEnt", null);
  };
  var DI = [current_sel_ent.Guid];
  // 检查要删除的对象是否有检测数据
  var isDetection = null;
  //是否为排查
  let isInvestigate =
    store.state.cadModules.rlProject_detail.businessTypePermission ==
    "investigate";

  if (
    current_sel_ent.Attribute ||
    (isInvestigate && current_sel_ent.classTypeName == "rlPartitionWallSeg")
  ) {
    //判断是否是墙或者梁，若是，检查是否有板，若有，则检查板是否检测数据
    if (
      (current_sel_ent.classTypeName == "rlWallSeg" ||
        current_sel_ent.classTypeName == "rlBeamSeg") &&
      current_sel_ent.m_gridData.classTypeName == "rlGrid"
    ) {
      if (
        !current_sel_ent.m_gridData.m_beamId ||
        !current_sel_ent.m_gridData.m_wallId
      ) {
        DI.push(...current_sel_ent.m_gridData.m_slabIds);
      }
    }
    isDetection = DI && DI.length ? await getDelText(DI) : null; //存在数据时才需要调用接口
  }
  if (isDetection) {
    // 如果有检测数据,则提示用户确认是否删除
    var type = await VXETable.modal.confirm(
      "当前构件检测数据已录,请确认是否删除"
    );
    if (type === "confirm") {
      await setDelModule(DI);
      delFn();
    }
  } else {
    // 如果没有检测数据,直接删除
    delFn();
  }
};

// 框选类型过滤集合
export const handle_type_entiy = (selectObj, type) => {
  if (type == "rlJoint") {
    if (selectObj.classTypeName == "rlJoint") {
      return selectObj;
    }
  }
  if (type == "rlGrid") {
    if (selectObj.classTypeName == "rlGrid") {
      return selectObj;
    }
  }
  if (type == "rlWallSeg") {
    let rlWallObj = rlAppObj.rlMxDrawObject.getMxEntity(selectObj.m_wallId);
    if (rlWallObj) {
      return rlWallObj;
    }
  }
  if (type == "rlColSeg") {
    let rlColumnObj = rlAppObj.rlMxDrawObject.getMxEntity(selectObj.m_cloumId);
    if (rlColumnObj) {
      return rlColumnObj;
    }
  }
  if (type == "rlBeamSeg") {
    let rlBeamObj = rlAppObj.rlMxDrawObject.getMxEntity(selectObj.m_beamId);
    if (rlBeamObj) {
      return rlBeamObj;
    }
  }
  return null;
};

// // 复制操作
// export const copy_entiy = async (topBtnActive, ids, context) => {
//   if (topBtnActive && topBtnActive.id == 405) {
//     if (!ids.length) return
//     let sp = ''
//     let ep = ''
//     //选择基点
//     Message && Message.closeAll()

//     let messageObj = Message({
//       duration: 0,
//       message: '请选择基点',
//       type: 'info'
//     })

//     select_point().then(res => {
//       sp = res
//       messageObj.message = '请指定第二个位置'
//       select_point().then(res2 => {
//         //选择基点移动后的位置
//         ep = res2
//         //
//         //计算偏移向量
//         let vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0)

//         ids.forEach(item => {
//           let mcObj = item.getMcDbEntity()
//           //
//           let selectObj = rlAppObj.rlMxDrawObject.getMxEntity(
//             Number(mcObj.getxDataString('mcObjectId').val)
//           )

//           if (selectObj.classTypeName == 'rlJoint') {
//             copy_Joint(selectObj, vecMove)
//           } else if (selectObj.classTypeName == 'rlGrid') {
//             //
//             copy_Grid(selectObj, vecMove)
//           }

//           //selectObj.transformBy(vecMove)
//         })
//         messageObj.close()
//         rlAppObj.rlMxDrawObject.updateDisplay()
//       })
//     })
//   }
// }

export const copy_entiy = async () => {
  userSelect().then((ids) => {
    if (!ids.length) return;
    let sp = "";
    let ep = "";
    //选择基点
    Message && Message.closeAll();

    let messageObj = Message({
      duration: 0,
      message: "请选择基点",
      type: "info",
    });

    select_point().then((res) => {
      sp = res;
      messageObj.message = "请指定第二个位置";
      select_point().then((res2) => {
        //选择基点移动后的位置
        ep = res2;
        //
        //计算偏移向量
        let vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0);

        ids.forEach((item) => {
          let mcObj = item.getMcDbEntity();
          //
          let selectObj = rlAppObj.rlMxDrawObject.getMxEntity(
            Number(mcObj.getxDataString("mcObjectId").val)
          );

          if (selectObj.classTypeName == "rlJoint") {
            copy_Joint(selectObj, vecMove);
          } else if (selectObj.classTypeName == "rlGrid") {
            //
            copy_Grid(selectObj, vecMove);
          }

          //selectObj.transformBy(vecMove)
        });
        messageObj.close();
        rlAppObj.rlMxDrawObject.updateDisplay();
        store.commit(
          "platBtns/CHANGE_TOPBTNACT",
          store.state.platBtns.topBtnActive
        );
      });
    });
  });
};

//复制节点
const copy_Joint = (currentEnt, _mat) => {
  if (currentEnt) {
    //复制节点
    let objJt = currentEnt.clone(1);
    objJt.transformBy(_mat);
    rlAppObj.rlMxDrawObject.addMxEntity(objJt);
    objJt.mcDbPointId = rlAppObj.mxcadObject.drawEntity(objJt.mcDbPoint);
    let rlGroup = rlAppObj.rlMxDatabase.addGroup(objJt.m_groupName);
    rlGroup.append(objJt);

    //复制节点上的柱子
    let colId = currentEnt.m_cloumId;
    let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(colId);

    if (objtmp) {
      let objCol = objtmp.myClone();
      objCol.m_JointData = objJt;
      rlAppObj.rlMxDrawObject.addMxEntity(objCol);
      // objCol.mcDbPointId = rlAppObj.mxcadObject.drawEntity(objCol.mcDbPoint)
      let rlGroup = rlAppObj.rlMxDatabase.addGroup(objCol.m_groupName);
      rlGroup.append(objCol);
    }
  }
};

//复制网格
export const copy_Grid = (currentEnt, _mat) => {
  if (currentEnt) {
    //复制节点
    let jtObj1 = currentEnt.m_stJoint.clone(1);
    jtObj1.transformBy(_mat);
    rlAppObj.rlMxDrawObject.addMxEntity(jtObj1);
    jtObj1.mcDbPointId = rlAppObj.mxcadObject.drawEntity(jtObj1.mcDbPoint);

    let jtObj2 = currentEnt.m_edJoint.clone(1);
    jtObj2.transformBy(_mat);
    rlAppObj.rlMxDrawObject.addMxEntity(jtObj2);
    jtObj2.mcDbPointId = rlAppObj.mxcadObject.drawEntity(jtObj2.mcDbPoint);

    // 添加到组
    let rlPointGroup = rlAppObj.rlMxDatabase.addGroup(jtObj1.m_groupName);
    rlPointGroup.append(jtObj1);
    rlPointGroup.append(jtObj2);

    //复制网格
    let objGrid = currentEnt.clone(1);
    objGrid.m_stJoint = jtObj1;
    objGrid.m_edJoint = jtObj2;
    objGrid.points = [
      new THREE.Vector3(...objGrid.m_stJoint.m_pt),
      new THREE.Vector3(...objGrid.m_edJoint.m_pt),
    ];
    rlAppObj.rlMxDrawObject.addMxEntity(objGrid);
    objGrid.mcDbGridId = rlAppObj.mxcadObject.drawEntity(objGrid.mcDbGrid);
    let rlGroup = rlAppObj.rlMxDatabase.addGroup(objGrid.m_groupName);
    rlGroup.append(objGrid);

    //复制网格上的墙
    let wallId = currentEnt.m_wallId;
    let objWalltmp = rlAppObj.rlMxDrawObject.getMxEntity(wallId);
    if (objWalltmp && objWalltmp.visible) {
      let objCol = objWalltmp.myClone();
      objCol.m_gridData = objGrid;
      rlAppObj.rlMxDrawObject.addMxEntity(objCol);
      let rlGroup = rlAppObj.rlMxDatabase.addGroup(objCol.m_groupName);
      rlGroup.append(objCol);
    }

    //复制网格上的梁
    let beamId = currentEnt.m_beamId;
    let objBeamtmp = rlAppObj.rlMxDrawObject.getMxEntity(beamId);
    if (objBeamtmp && objBeamtmp.visible) {
      let objCol = objBeamtmp.myClone();
      objCol.m_gridData = objGrid;
      rlAppObj.rlMxDrawObject.addMxEntity(objCol);
      let rlGroup = rlAppObj.rlMxDatabase.addGroup(objCol.m_groupName);
      rlGroup.append(objCol);
    }
  }
};

// 移动操作
export const move_entiy = async (topBtnActive, ids, context) => {
  if (topBtnActive && topBtnActive.id == 401) {
    if (!ids.length) return;
    let sp = "";
    let ep = "";
    //store.commit('platBtns/SET_FIXATIONSHOW', true)
    // store.commit('platBtns/SET_MOVEFIXATIONFROM')//清空表单数据

    //选择基点
    Message && Message.closeAll();
    let messageObj = Message({
      duration: 0,
      message: "请选择基点",
      type: "info",
    });

    select_point().then((res) => {
      sp = res;
      messageObj.message = "请指定第二个位置";
      select_point().then((res2) => {
        //选择基点移动后的位置
        ep = res2;
        //
        //计算偏移向量
        let vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0);

        move_ents(ids, vecMove);

        messageObj.close();
        rlAppObj.rlMxDrawObject.updateDisplay();
      });
    });
  }
};

const getMirroredPoint = (linePoint1, linePoint2, point) => {
  // 获取直线方向向量
  let dx = linePoint2.x - linePoint1.x;
  let dy = linePoint2.y - linePoint1.y;
  let dz = linePoint2.z - linePoint1.z;

  // 计算 AP 向量
  let apx = point.x - linePoint1.x;
  let apy = point.y - linePoint1.y;
  let apz = point.z - linePoint1.z;

  // 计算投影比例 t
  let dotProduct = apx * dx + apy * dy + apz * dz;
  let lenSquared = dx * dx + dy * dy + dz * dz;
  let t = dotProduct / lenSquared;

  // 计算投影点 Q
  let qx = linePoint1.x + t * dx;
  let qy = linePoint1.y + t * dy;
  let qz = linePoint1.z + t * dz;

  // 计算镜像点 P'
  let mirroredX = 2 * qx - point.x;
  let mirroredY = 2 * qy - point.y;
  let mirroredZ = 2 * qz - point.z;

  return new THREE.Vector3(mirroredX, mirroredY, mirroredZ);
};

//批量镜像
export const mirrorEntArray = async (ids, sp, ep) => {
  createConfirmButton("mirror");

  Message.info("请选择要镜像的实体");
  const getIds = async (ids) => {
    if (!ids.length) return;
    try {
      store.commit("cadModules/setSnapPoint", {
        snapPoint: null,
        needCatchSnap: true,
      });
      highlightEntityArray(ids, false);
      setIds(ids);
    } catch (error) {
      console.error("镜像实体失败", error);
    }
  };
  //框选实体
  userSelect(getIds);
};

export const MirrorEnts = async (ids) => {
  let previewObjIds = [];
  let lastSp = null;
  let lastEp = null;
  //复制过程预览
  const previewEnts = (ids, sp, ep) => {
    if (!ids.length) return;

    const pt1 = new McGePoint3d(sp.x, sp.y, 0);
    const pt2 = new McGePoint3d(ep.x, ep.y, 0);
    //判断lastSp和lastEp是否与sp和ep相同
    if (lastSp && lastEp) {
      if (
        ptIsEqual(new McGePoint3d(lastSp.x, lastSp.y, 0), sp) &&
        ptIsEqual(new McGePoint3d(lastEp.x, lastEp.y, 0), ep)
      ) {
        return;
      }
    }
    lastSp = pt1;
    lastEp = pt2;

    if (previewObjIds.length) {
      previewObjIds.forEach((id) => {
        id.getMcDbEntity().erase();
      });
      previewObjIds = [];
    }
    previewObjIds = new Array(ids.length);
    for (let i = 0; i < ids.length; i++) {
      let obj = ids[i].getMcDbEntity().clone();
      obj.mirror(pt1, pt2);
      previewObjIds[i] = rlAppObj.mxcadObject.drawEntity(obj);
    }
  };

  const operateMirror = async (ids) => {
    if (!ids.length) return;
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: true,
    });
    highlightEntityArray(ids);
    await new Promise((resolve) => {
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      getPoint.setMessage("请指定镜像线的第一点");

      let pt1 = null;
      let originalPoint = null;
      // 关闭正交模式
      fixOrthogonal(false);

      getPoint.setInputToucheType(1);
      // Message.info("请选择基点");
      getPoint.go((status) => {
        if (status !== 0) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          clearEntityArrayHighlight();
          store.commit("platBtns/SET_ISMOVEORCOPY", false);
          return;
        }
        store.commit("platBtns/SET_ISMOVEORCOPY", true);
        // 开启正交模式
        fixOrthogonal(true);
        pt1 = store.state.cadModules.snapPoint.snapPoint; //getPoint.value();

        if (!pt1) {
          pt1 = getPoint.value();
          // 启用捕捉优化
          let snapPoint = enableSnapCorrection(pt1, null, true);
          pt1 = snapPoint ? snapPoint : pt1;
        }

        getPoint.setBasePt(pt1);
        originalPoint = pt1;

        store.commit("cadModules/setSnapPoint", {
          snapPoint: null,
          needCatchSnap: false,
        });

        const mxcad = MxCpp.getCurrentMxCAD();
        mxcad.addDimStyle(
          "MoveDistDimStyle",
          "41,0.18,141,0.09,140,0,40,200",
          "77,1,271,3,73,1",
          "",
          ""
        );

        mxcad.drawDimStyle = "MoveDistDimStyle";
        let mDimensionId = mxcad.drawDimAligned(
          originalPoint.x,
          originalPoint.y,
          originalPoint.x,
          originalPoint.y,
          originalPoint.x,
          originalPoint.y
        );
        const mDimensionObj = mDimensionId.getMcDbEntity();
        // //添加输入框
        // let inputElement = getInputElement();
        // if (!inputElement) {
        //   inputElement = createInputElement(mDimensionObj);
        // } else {
        //   setCurrDataObj(mDimensionObj);
        //   // inputElement.style.display = "block";
        //   setContainerShow(true);
        // }
        getPoint.setMessage("请指定镜像线的第二点");

        // 设置第一个点位置
        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          let snapPoint = enableSnapCorrection(
            currentPoint,
            originalPoint,
            true
          );
          currentPoint = snapPoint ? snapPoint : currentPoint;
          // const jointpoint = getMinDistJoint(currentPoint);
          const dx = currentPoint.x - pt1.x;
          const dy = currentPoint.y - pt1.y;
          const dz = 0;

          // 鼠标位置
          // ids.forEach((objId) => {
          //   const ent = objId.getMcDbEntity().clone();
          //   ent.mirror(
          //     new McGePoint3d(originalPoint.x, originalPoint.y, 0),
          //     new McGePoint3d(currentPoint.x, currentPoint.y, 0)
          //   );
          //   pWorldDraw.drawMcDbEntity(ent);
          // });
          previewEnts(ids, originalPoint, currentPoint);
          // 更新 pt1 为 鼠标位置
          pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);

          mDimensionObj.xLine2Point = new McGePoint3d(
            currentPoint.x,
            currentPoint.y,
            currentPoint.z
          );
          const midX = (originalPoint.x + currentPoint.x) / 2;
          const midY = (originalPoint.y + currentPoint.y) / 2;
          mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);

          // setInputElementPosition(
          //   originalPoint.distanceTo(currentPoint).toFixed(0),
          //   midX,
          //   midY
          // );
        });

        // Message.info("请选择终点");
        // 第二次点击鼠标
        getPoint.setInputToucheType(2);
        getPoint.go(async (status2) => {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          if (status2 !== 0) {
            if (originalPoint) {
              // 移动回原始位置
              for (const id of previewObjIds) {
                id.getMcDbEntity().erase();
              }
              // 删除标注
              mDimensionObj.erase();
            }
            clearEntityArrayHighlight();
            store.commit("platBtns/SET_ISMOVEORCOPY", false);
            return;
          }

          // 获取最终点位置
          let finalPoint = pt1;

          //删除预览
          previewObjIds.forEach((id) => {
            id.getMcDbEntity().erase();
          });

          //删除标注
          mDimensionObj.erase();

          store.commit("globalData/setCanAddRawStep", true);
          //复制实体
          await copyEnts(ids, originalPoint, finalPoint, true);
          await saveDatabaseStore();
          store.commit("platBtns/SET_ISMOVEORCOPY", false);
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识

          setTimeout(() => {
            clearEntityArrayHighlight();
            rlAppObj.rlMxDrawObject.updateDisplay();
          }, 200);
          resolve();
        });
      });
    });
  };
  await operateMirror(ids);
  clearEntityArrayHighlight();
  rlAppObj._rlMx.MxFun.stopRunCommand();
};

//批量复制
export const CopyEntArray = async () => {
  createConfirmButton("copy");

  Message.info("请选择要复制的实体");
  const getIds = async (ids) => {
    if (!ids.length) return;
    try {
      store.commit("cadModules/setSnapPoint", {
        snapPoint: null,
        needCatchSnap: true,
      });
      highlightEntityArray(ids, false);
      setIds(ids);
    } catch (error) {
      console.error("复制实体失败", error);
    }
  };
  //框选实体
  userSelect(getIds);
};

export const CopyEnts = async (ids) => {
  let previewObjIds = [];
  //复制过程预览
  const previewEnts = (ids, sp, ep) => {
    if (!ids.length) return;
    if (previewObjIds.length) {
      previewObjIds.forEach((id) => {
        let obj = id.getMcDbEntity();
        obj.move(
          new McGePoint3d(sp.x, sp.y, 0),
          new McGePoint3d(ep.x, ep.y, 0)
        );
      });
    } else {
      for (const id of ids) {
        let obj = id.getMcDbEntity().clone();
        obj.move(
          new McGePoint3d(sp.x, sp.y, 0),
          new McGePoint3d(ep.x, ep.y, 0)
        );
        previewObjIds.push(rlAppObj.mxcadObject.drawEntity(obj));
      }
    }
  };

  const operateCopy = async (ids) => {
    if (!ids.length) return;
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: true,
    });
    highlightEntityArray(ids);
    await new Promise((resolve) => {
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      let pt1 = null;
      let originalPoint = null;
      // 关闭正交模式
      fixOrthogonal(false);

      getPoint.setInputToucheType(1);
      // Message.info("请选择基点");
      getPoint.go((status) => {
        if (status !== 0) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          clearEntityArrayHighlight();
          return;
        }
        store.commit("platBtns/SET_ISMOVEORCOPY", true);
        // 开启正交模式
        fixOrthogonal(true);
        pt1 = store.state.cadModules.snapPoint.snapPoint; //getPoint.value();

        if (!pt1) {
          pt1 = getPoint.value();
          // 启用捕捉优化
          let snapPoint = enableSnapCorrection(pt1, null, true);
          pt1 = snapPoint ? snapPoint : pt1;
        }

        getPoint.setBasePt(pt1);
        originalPoint = pt1;

        store.commit("cadModules/setSnapPoint", {
          snapPoint: null,
          needCatchSnap: false,
        });

        const mxcad = MxCpp.getCurrentMxCAD();
        mxcad.addDimStyle(
          "MoveDistDimStyle",
          "41,0.18,141,0.09,140,0,40,200",
          "77,1,271,3,73,1",
          "",
          ""
        );

        mxcad.drawDimStyle = "MoveDistDimStyle";
        let mDimensionId = mxcad.drawDimAligned(
          originalPoint.x,
          originalPoint.y,
          originalPoint.x,
          originalPoint.y,
          originalPoint.x,
          originalPoint.y
        );
        const mDimensionObj = mDimensionId.getMcDbEntity();
        //添加输入框
        let inputElement = getInputElement();
        if (!inputElement) {
          inputElement = createInputElement(mDimensionObj);
        } else {
          setCurrDataObj(mDimensionObj);
          // inputElement.style.display = "block";
          setContainerShow(true);
        }

        //设置输入框不能输入
        inputElement.readOnly = true;

        // 设置第一个点位置
        getPoint.setUserDraw((currentPoint) => {
          let snapPoint = enableSnapCorrection(
            currentPoint,
            originalPoint,
            true
          );
          currentPoint = snapPoint ? snapPoint : currentPoint;
          // const jointpoint = getMinDistJoint(currentPoint);
          const dx = currentPoint.x - pt1.x;
          const dy = currentPoint.y - pt1.y;
          const dz = 0;

          // 鼠标位置
          previewEnts(
            ids,
            new McGePoint3d(pt1.x, pt1.y, pt1.z),
            new McGePoint3d(pt1.x + dx, pt1.y + dy, pt1.z + dz)
          );
          // 更新 pt1 为 鼠标位置
          pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);

          mDimensionObj.xLine2Point = new McGePoint3d(
            currentPoint.x,
            currentPoint.y,
            currentPoint.z
          );
          const midX = (originalPoint.x + currentPoint.x) / 2;
          const midY = (originalPoint.y + currentPoint.y) / 2;
          mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);

          setInputElementPosition(
            originalPoint.distanceTo(currentPoint).toFixed(0),
            midX,
            midY
          );
        });

        // Message.info("请选择终点");
        // 第二次点击鼠标
        getPoint.setInputToucheType(2);
        getPoint.go((status2) => {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          if (status2 !== 0) {
            if (originalPoint) {
              // 移动回原始位置
              for (const id of previewObjIds) {
                id.getMcDbEntity().erase();
              }
              // 删除标注
              mDimensionObj.erase();
            }
            clearEntityArrayHighlight();
            store.commit("platBtns/SET_ISMOVEORCOPY", false);
            return;
          }

          //设置输入框可以输入
          inputElement.readOnly = false;

          // 获取最终点位置
          let finalPoint = pt1;
          // 鼠标位置
          previewEnts(
            ids,
            new McGePoint3d(pt1.x, pt1.y, pt1.z),
            new McGePoint3d(finalPoint.x, finalPoint.y, finalPoint.z)
          );

          // 计算移动的距离和角度
          const dx = finalPoint.x - originalPoint.x;
          const dy = finalPoint.y - originalPoint.y;
          const distance = Math.sqrt(dx * dx + dy * dy).toFixed(2);
          const angle = (Math.atan2(dy, dx) * (180 / Math.PI)).toFixed(2); // 转换为角度

          // let res = moveModel();
          // if (res == false) {
          //   // 删除标注
          //   mDimensionObj.erase();
          // previewEnts(
          //   ids,
          //   new McGePoint3d(pt1.x, pt1.y, pt1.z),
          //   new McGePoint3d(originalPoint.x, originalPoint.y, originalPoint.z)
          // );
          // }
          //
          store.commit("cadModules/setMoveDistObj", {
            idArray: ids,
            distId: mDimensionId,
            previewObjIds: previewObjIds,
            st: new THREE.Vector3(originalPoint.x, originalPoint.y, 0),
            ed: new THREE.Vector3(finalPoint.x, finalPoint.y, 0),
          });

          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识

          setTimeout(() => {
            clearEntityArrayHighlight();
            rlAppObj.rlMxDrawObject.updateDisplay();
          }, 200);
          resolve();
        });
      });
    });
  };
  await operateCopy(ids);
  clearEntityArrayHighlight();
  rlAppObj._rlMx.MxFun.stopRunCommand();
};

export const copyEnts = async (
  ids,
  sp,
  ep,
  isMirror = false,
  needCheck = true //是否需要校验模型重叠问题
) => {
  if (!ids.length) return;
  if (needCheck) {
    if (!checkMoveData(ids, sp, ep, true, isMirror)) {
      Message.warning("复制后会造成构件重叠，请重新选择复制数据及复制落点");
      store.commit("globalData/setCanAddRawStep", false); //删除撤销步数
      return;
    }
  }

  try {
    //添加loading
    showFullScreenLoading("正在复制实体...");
    //计算偏移向量
    let vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0);
    let objDatas = {};

    for (const id of ids) {
      if (id) {
        let entData = getEntityById(id);
        if (entData) {
          if (!objDatas[entData.classTypeName]) {
            objDatas[entData.classTypeName] = [];
          }
          if (
            objDatas[entData.classTypeName].find(
              (item) => item.Guid == entData.Guid
            )
          ) {
            continue;
          }
          objDatas[entData.classTypeName].push(entData);
        }
      }
    }
    let copyRes = {}; //记录复制数据与原数据的关联

    let copyJointsDataLink = {}; //记录复制后的点与原点的映射关系
    if (objDatas["rlJoint"]) {
      for (const item of objDatas["rlJoint"]) {
        let pt = new THREE.Vector3(...item.m_pt);
        if (isMirror) {
          pt = getMirroredPoint(sp, ep, pt);
        } else {
          pt.add(vecMove);
        }
        let joint = await copyJointData(pt, item.HDiff);
        if (joint) {
          copyJointsDataLink[item.Guid] = joint;
          copyRes[item.Guid] = joint;
        }
      }
    }

    // let copyAxisDataLink = {}; //记录复制后的轴线与原轴线的映射关系
    // if (objDatas["rlAxis"]) {
    //   for (const item of objDatas["rlAxis"]) {
    //     let axis = await copyAxisData(
    //       item,
    //       sp,
    //       ep,
    //       copyJointsDataLink,
    //       isMirror
    //     );
    //     if (axis) {
    //       copyAxisDataLink[item.Guid] = axis;
    //       copyRes[item.Guid] = axis;
    //     }
    //   }
    // }

    let copyGridDataLink = {}; //记录复制后的网格与原网格的映射关系
    if (objDatas["rlGrid"]) {
      for (const item of objDatas["rlGrid"]) {
        let grid = await copyGridData(
          item,
          sp,
          ep,
          // copyAxisDataLink,
          isMirror
        );
        if (grid) {
          copyGridDataLink[item.Guid] = grid;
          copyRes[item.Guid] = grid;
        }
      }
    }

    //复制柱
    let copyColumnDataLink = {}; //记录复制后的柱与原柱的映射关系
    if (objDatas["rlColSeg"]) {
      for (const item of objDatas["rlColSeg"]) {
        let pt = new THREE.Vector3(...item.m_JointData.m_pt);
        if (isMirror) {
          pt = getMirroredPoint(sp, ep, pt);
        } else {
          pt.add(vecMove);
        }

        let jointObj = copyJointsDataLink[item.m_JointData.Guid]
          ? copyJointsDataLink[item.m_JointData.Guid]
          : await copyJointData(pt, item.m_JointData.HDiff);
        if (!jointObj) {
          continue;
        }

        let eccX = item.EccX;
        let eccY = item.EccY;
        if (isMirror) {
          let colPt = new THREE.Vector3(...item.m_JointData.m_pt);
          colPt.x += item.EccX;
          colPt.y += item.EccY;
          colPt = getMirroredPoint(sp, ep, colPt);
          eccX = colPt.x - pt.x;
          eccY = colPt.y - pt.y;
        }

        let newObj = new rlColumnData();
        newObj.initData({
          m_sectParamData: item.m_sectParamData,
          EccX: eccX,
          EccY: eccY,
          Rotation: item.Rotation,
          HDiffB: item.HDiffB,
          LevelB: item.LevelB,
          Height: item.Height,
          Color: item.Color,
          m_JointData: jointObj,
          Attribute: item.Attribute,
          CurrtSect: item.CurrtSect,
          StdFlrGuid: item.StdFlrGuid,
          flrHeight: item.flrHeight,
        });

        await newObj.draw();
        await addEntityToDrawing(newObj);
        copyRes[item.Guid] = newObj;
        copyColumnDataLink[item.Guid] = newObj;
      }
    }

    //复制梁
    let copyBeamDataLink = {}; //记录复制后的梁与原梁的映射关系
    if (objDatas["rlBeamSeg"]) {
      for (const item of objDatas["rlBeamSeg"]) {
        let gridObj = copyGridDataLink[item.m_gridData.Guid]
          ? copyGridDataLink[item.m_gridData.Guid]
          : await copyGridData(
              item.m_gridData,
              sp,
              ep,
              copyJointsDataLink,
              // copyAxisDataLink,
              isMirror
            );
        if (!gridObj) {
          continue;
        }

        let newObj = new rlBeamData();
        newObj.initData({
          m_sectParamData: item.m_sectParamData,
          Ecc: item.Ecc,
          HDiff1: item.HDiff1,
          HDiff2: item.HDiff2,
          Rotation: item.Rotation,
          LevelB: item.LevelB,
          Height: item.Height,
          m_gridData: gridObj,
          Color: item.Color,
          beamColor: item.beamColor,
          subBeamColor: item.subBeamColor,
          ringBeamColor: item.ringBeamColor,
          Attribute: item.Attribute,
          StdFlrGuid: item.StdFlrGuid,
        });
        await newObj.draw();
        await addEntityToDrawing(newObj);
        copyRes[item.Guid] = newObj;
        copyBeamDataLink[item.Guid] = newObj;
      }
    }

    // //复制楼板
    // let copySlabDataLink = {}; //记录复制后的楼板与原楼板的映射关系
    // if (objDatas["rlSlab"]) {
    //   for (const slab of objDatas["rlSlab"]) {
    //     let GridsGuid = slab.GridsGuid;
    //     let GridsGuidArray = GridsGuid.split(",");
    //     //剔除空字符串
    //     GridsGuidArray = GridsGuidArray.filter((item) => item !== "");
    //     let isCopy = true;
    //     let girdData = [];

    //     for (const gridGuid of GridsGuidArray) {
    //       if (!copyGridDataLink[gridGuid]) {
    //         isCopy = false;
    //         break;
    //       }
    //       let gridObj = copyGridDataLink[gridGuid];
    //       const isArc =
    //         gridObj.m_centerJoint ||
    //         (gridObj.m_Axis && gridObj.m_Axis.IsMainAxis < 0);
    //       if (isArc) {
    //         const stPoint = new McGePoint3d(...gridObj.m_stJoint.m_pt);
    //         const edPoint = new McGePoint3d(...gridObj.m_edJoint.m_pt);
    //         const centerPoint = new McGePoint3d(
    //           gridObj.centerPoint[0],
    //           gridObj.centerPoint[1],
    //           0
    //         );
    //         const dRadius = gridObj.mcDbGrid.radius;
    //         const points = getArcPoints(stPoint, edPoint, centerPoint, dRadius);
    //         const pointsStr = points
    //           .map((item) => `${item.x},${item.y},0`)
    //           .join(",");
    //         girdData.push(`${gridObj.Guid}:[${pointsStr}],`);
    //       } else {
    //         girdData.push(
    //           `${gridObj.Guid}:[${[
    //             ...gridObj.m_stJoint.m_pt,
    //             ...gridObj.m_edJoint.m_pt,
    //           ]}],`
    //         );
    //       }
    //     }
    //     if (!isCopy) {
    //       continue;
    //     }
    //     let data = "";
    //     girdData.forEach((item) => (data += item));
    //     //获取楼板绘制数据
    //     const createSlab = new CreateSlab();
    //     let res = createSlab.getSlabJsonData(data);
    //     if (!res) {
    //       console.log("获取楼板绘制数据失败", data);
    //       continue;
    //     }

    //     const model = JSON.parse(res)?.Slab;
    //     const modelKeys = Object.keys(model);
    //     const modelData = Object.values(model).flat();

    //     for (let index = 0; index < modelData.length; index++) {
    //       if (!modelKeys[index]) continue;
    //       const item = modelData[index];

    //       //判断当前新增楼板在当前楼层中是否有一模一样的重叠楼板,如果有则不布置新的楼板,且更新板厚
    //       //判断是否重叠

    //       //新板的2维点集的总和
    //       let NewSlabTotalPoints = [0, 0, 0];
    //       let New2dUpView = item["2DUpView"];
    //       for (let index = 0; index < New2dUpView.length - 2; index += 3) {
    //         NewSlabTotalPoints[0] += Math.floor(New2dUpView[index]);
    //         NewSlabTotalPoints[1] += Math.floor(New2dUpView[index + 1]);
    //       }
    //       let key = NewSlabTotalPoints.join(",");

    //       //剔除重复的guid
    //       let gridsGuid = modelKeys[index].split(",");
    //       //剔除重复的guid
    //       gridsGuid = [...new Set(gridsGuid)];
    //       gridsGuid = gridsGuid.join(",");

    //       let rlSlabObject = new rlSlabData();
    //       rlSlabObject.points = item.Points;
    //       rlSlabObject.index2dData = item["2DUpView"];
    //       rlSlabObject.member = true;
    //       rlSlabObject.GridsGuid = gridsGuid;
    //       rlSlabObject.VertexX = "";
    //       rlSlabObject.VertexY = "";
    //       rlSlabObject.VertexZ = "";
    //       for (let index = 0; index < item["2DUpView"].length - 2; index += 3) {
    //         rlSlabObject.VertexX += item["2DUpView"][index] + ",";
    //       }
    //       for (let index = 1; index < item["2DUpView"].length; index += 3) {
    //         rlSlabObject.VertexY += item["2DUpView"][index] + ",";
    //       }
    //       for (let index = 2; index < item["2DUpView"].length; index += 3) {
    //         rlSlabObject.VertexZ += item["2DUpView"][index] + ",";
    //       }

    //       rlSlabObject.Color = slab.Color;

    //       rlSlabObject.LevelB = slab.LevelB;
    //       rlSlabObject.Height = slab.Height;
    //       rlSlabObject.Attribute = 2;
    //       rlSlabObject.m_sectParamData = slab.m_sectParamData;
    //       rlSlabObject.Thickness = slab.Thickness;
    //       rlSlabObject.RoomIsHole = slab.RoomIsHole;
    //       rlSlabObject.draw();
    //       await addEntityToDrawing(rlSlabObject, false);
    //       copyRes[item.Guid] = rlSlabObject;
    //       copySlabDataLink[slab.Guid] = rlSlabObject;

    //       //将楼板和网格关联
    //       let gridGuidsArray = gridsGuid.split(",");
    //       if (gridGuidsArray.length > 0) {
    //         gridGuidsArray.forEach((guidTmp) => {
    //           if (copyGridDataLink[guidTmp]) {
    //             copyGridDataLink[guidTmp].m_slabIds.push(rlSlabObject.Guid);
    //             rlSlabObject.gridsObjs.push(copyGridDataLink[guidTmp]);
    //           }
    //         });
    //       }
    //     }
    //   }
    // }

    // //复制板洞
    // if (objDatas["rlSlabHole"]) {
    //   for (const item of objDatas["rlSlabHole"]) {
    //     let pt = new THREE.Vector3(...item.m_JointData.m_pt);
    //     if (isMirror) {
    //       pt = getMirroredPoint(sp, ep, pt);
    //     } else {
    //       pt.add(vecMove);
    //     }

    //     let jointObj = copyJointsDataLink[item.m_JointData.Guid]
    //       ? copyJointsDataLink[item.m_JointData.Guid]
    //       : await copyJointData(pt);
    //     if (!jointObj) {
    //       continue;
    //     }

    //     let eccX = item.EccX;
    //     let eccY = item.EccY;
    //     if (isMirror) {
    //       //EccX是节点在x轴的偏移量，EccY是节点在y轴的偏移量
    //       //计算镜像后的EccX和EccY
    //       let holePt = new THREE.Vector3(...item.m_JointData.m_pt);
    //       holePt.x += item.EccX;
    //       holePt.y += item.EccY;
    //       holePt = getMirroredPoint(sp, ep, holePt);
    //       eccX = holePt.x - pt.x;
    //       eccY = holePt.y - pt.y;
    //     }

    //     let newObj = new rlSlabHoleData();
    //     newObj.initData({
    //       m_sectParamData: item.m_sectParamData,
    //       m_JointData: jointObj,
    //       Height: item.Height,
    //       LevelB: item.LevelB,
    //       EccX: eccX,
    //       EccY: eccY,
    //       HDiffB: item.HDiffB,
    //       Rotation: item.Rotation,
    //       m_SlabData: copySlabDataLink[item.m_SlabData.Guid],
    //       slabThickness: item.slabThickness,
    //       Attribute: item.Attribute,
    //     });

    //     await newObj.draw();
    //     await addEntityToDrawing(newObj);
    //     copyRes[item.Guid] = newObj;
    //     jointObj.m_SlabHoleId = newObj.Guid;
    //   }
    // }

    //复制墙
    let copyWallDataLink = {}; //记录复制后的墙与原墙的映射关系
    if (objDatas["rlWallSeg"]) {
      for (const item of objDatas["rlWallSeg"]) {
        let wall = await copyWallData(
          item,
          vecMove,
          copyGridDataLink,
          isMirror
        );

        if (wall) {
          copyWallDataLink[item.Guid] = wall;
          copyRes[item.Guid] = wall;
        }
      }
    }
    //复制隔墙
    let partitionWallLinkData = {}; //记录复制后的隔墙与原隔墙的映射关系
    if (objDatas["rlPartitionWallSeg"]) {
      for (const item of objDatas["rlPartitionWallSeg"]) {
        let obj = await copyPartitionWallData(
          item,
          sp,
          ep,
          copyGridDataLink,
          isMirror
        );
        if (obj) {
          partitionWallLinkData[item.Guid] = obj;
          copyRes[item.Guid] = obj;
        }
      }
    }
    //复制墙洞
    if (objDatas["rlWallHole"]) {
      for (const item of objDatas["rlWallHole"]) {
        let wallObj = null;
        let gridObj = null;
        if (item.m_gridData) {
          if (partitionWallLinkData[item.m_gridData.Guid]) {
            gridObj = partitionWallLinkData[item.m_gridData.Guid];
            wallObj = gridObj;
          } else if (copyGridDataLink[item.m_gridData.Guid]) {
            gridObj = copyGridDataLink[item.m_gridData.Guid];
            if (!item.m_gridData.m_wallId) {
              continue;
            }
            wallObj = copyWallDataLink[item.m_gridData.m_wallId];
          }
        }
        if (!wallObj) {
          continue;
        }

        let otherData = null;
        if (item.OtherData) {
          if (typeof item.OtherData === "string") {
            otherData = JSON.parse(item.OtherData);
            if (typeof otherData === "string") {
              otherData = JSON.parse(otherData);
            }
          } else {
            otherData = item.OtherData;
          }

          let startPoint = new THREE.Vector3(
            otherData.startPoint.x,
            otherData.startPoint.y,
            0
          );
          let endPoint = new THREE.Vector3(
            otherData.endPoint.x,
            otherData.endPoint.y,
            0
          );
          let doorLeftRight = otherData.doorLeftRight;
          let doorUpDown = otherData.doorUpDown;
          if (isMirror) {
            startPoint = getMirroredPoint(sp, ep, startPoint);
            endPoint = getMirroredPoint(sp, ep, endPoint);
            console.log("vecMove", vecMove);

            let vecMoveTmp = new THREE.Vector3(
              ep.x - sp.x,
              ep.y - sp.y,
              0
            ).normalize();
            if (
              vecMoveTmp.equals(new THREE.Vector3(0, 1, 0)) ||
              vecMoveTmp.equals(new THREE.Vector3(0, -1, 0))
            ) {
              doorUpDown = doorUpDown == 2 ? 1 : 2;
            } else if (
              vecMoveTmp.equals(new THREE.Vector3(1, 0, 0)) ||
              vecMove.equals(new THREE.Vector3(-1, 0, 0))
            ) {
              doorLeftRight = doorLeftRight == 2 ? 1 : 2;
            } else {
              doorLeftRight = doorLeftRight == 2 ? 1 : 2;
              doorUpDown = doorUpDown == 2 ? 1 : 2;
            }
          } else {
            startPoint.add(vecMove);
            endPoint.add(vecMove);
          }
          otherData = {
            startPoint: {
              x: startPoint.x,
              y: startPoint.y,
              z: 0,
            },
            endPoint: {
              x: endPoint.x,
              y: endPoint.y,
              z: 0,
            },
            doorLeftRight: doorLeftRight,
            doorUpDown: doorUpDown,
          };
        }

        let newObj = new rlWallHoleData();
        newObj.initData({
          m_sectParamData: item.m_sectParamData,
          m_wallEcc: wallObj.Ecc,
          Ecc: item.Ecc,
          Color: item.Color,
          HDiff: item.HDiff,
          m_wallThick: wallObj.m_sectParamData.B,
          m_gridData: gridObj,
          LevelB: item.LevelB,
          OtherData: otherData ? JSON.stringify(otherData) : item.OtherData,
          doorsWindowsType: item.doorsWindowsType,
          IsPartitionWall: item.IsPartitionWall,
          Mat: item.Mat,
          MatName: item.MatName,
          doorOpenType: item.doorOpenType,
        });
        newObj.draw();
        await addEntityToDrawing(newObj);
        copyRes[item.Guid] = newObj;
        wallObj.m_HoleId = newObj.Guid;
        wallObj.drawBreakWall();
      }
    }

    return copyRes;
  } catch (error) {
    console.error("复制实体失败", error);
  } finally {
    tryHideFullScreenLoading();
  }
};

const copyJointData = async (pt, HDiff) => {
  let joint = new rlJointData();
  joint.initData({ m_pt: [pt.x, pt.y, 0], HDiff });
  let existObj = await addEntityToDrawing(joint);
  if (!existObj) {
    existObj = joint;
  }
  return existObj;
};

const copyGridData = async (
  item,
  sp,
  ep,
  // copyAxisDataLink,
  isMirror = false
) => {
  if (!item) return null;

  // copyAxisDataLink[item.m_Axis.Guid] = axisObj;
  let vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0);
  // vecMove.normalize();

  let ptSt = new THREE.Vector3(...item.m_stJoint.m_pt);
  let stHDiff = item.m_stJoint.HDiff;
  if (isMirror) {
    ptSt = getMirroredPoint(sp, ep, ptSt);
  } else {
    ptSt.add(vecMove);
  }

  let ptEd = new THREE.Vector3(...item.m_edJoint.m_pt);
  let edHDiff = item.m_edJoint.HDiff;
  if (isMirror) {
    ptEd = getMirroredPoint(sp, ep, ptEd);
  } else {
    ptEd.add(vecMove);
  }

  let joint1 = await copyJointData(ptSt, stHDiff);
  let joint2 = await copyJointData(ptEd, edHDiff);
  if (!joint1 || !joint2) return null;

  if (item.m_centerJoint) {
    let centerPt = new THREE.Vector3(...item.m_centerJoint.m_pt);
    let centerHDiff = item.m_centerJoint.HDiff;
    if (isMirror) {
      centerPt = getMirroredPoint(sp, ep, centerPt);
    } else {
      centerPt.add(vecMove);
    }
    let centerJoint = await copyJointData(centerPt, centerHDiff);
    if (!centerJoint) {
      return null;
    }
    let grid = new rlGridArcData();
    if (isMirror) {
      grid.initData({
        m_stJoint: joint2,
        m_edJoint: joint1,
        m_centerJoint: centerJoint,
        StdFlrGuid: item.StdFlrGuid,
        centerPoint: centerJoint.m_pt,
        m_Axis: null,
      });
    } else {
      grid.initData({
        m_stJoint: joint1,
        m_edJoint: joint2,
        m_centerJoint: centerJoint,
        StdFlrGuid: item.StdFlrGuid,
        centerPoint: centerJoint.m_pt,
        m_Axis: null,
      });
    }

    let existObj = await addEntityToDrawing(grid);
    if (!existObj) {
      existObj = grid;
    }

    return existObj;
  } else {
    let grid = new rlGridData();
    grid.initData({
      m_stJoint: joint1,
      m_edJoint: joint2,
      StdFlrGuid: item.StdFlrGuid,
      m_Axis: null,
    });

    let existObj = await addEntityToDrawing(grid);
    if (!existObj) {
      existObj = grid;
    }

    return existObj;
  }
};

//复制墙
const copyWallData = async (
  item,
  vecMove,
  copyGridDataLink,
  isMirror = false
) => {
  let gridObj = copyGridDataLink[item.m_gridData.Guid]
    ? copyGridDataLink[item.m_gridData.Guid]
    : await copyGridData(item.m_gridData, vecMove, isMirror);
  if (!gridObj) {
    return null;
  }

  if (gridObj.m_wallId) {
    return getEntityData({
      Guid: gridObj.m_wallId,
      classTypeName: "rlWallSeg",
    });
  }

  let newObj = new rlWallData();
  newObj.initData({
    m_sectParamData: item.m_sectParamData,
    Ecc: item.Ecc,
    HDiff1: item.HDiff1,
    HDiff2: item.HDiff2,
    HDiffB: item.HDiffB,
    LevelB: item.LevelB,
    Height: item.Height,
    m_gridData: gridObj,
    Color: item.Color,
    Attribute: item.Attribute,
    StdFlrGuid: item.StdFlrGuid,
  });
  await newObj.draw();
  await addEntityToDrawing(newObj);
  return newObj;
};

//复制隔墙
const copyPartitionWallData = async (
  item,
  sp,
  ep,
  copyGridDataLink,
  isMirror = false
) => {
  let vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0);
  let gridObj = null;
  if (item.m_gridData) {
    gridObj =
      copyGridDataLink && copyGridDataLink[item.m_gridData.Guid]
        ? copyGridDataLink[item.m_gridData.Guid]
        : await copyGridData(item.m_gridData, sp, ep, isMirror);
  }

  if (gridObj && gridObj.m_partitionWallId) {
    return getEntityData({
      Guid: gridObj.m_partitionWallId,
      classTypeName: "rlPartitionWallSeg",
    });
  }

  let otherData = null;
  if (!gridObj && item.OtherData) {
    //判断item.OtherData是否为字符串
    let drawData = null;
    if (typeof item.OtherData === "string") {
      drawData = JSON.parse(item.OtherData);
      if (typeof drawData === "string") {
        drawData = JSON.parse(drawData);
      }
    } else {
      drawData = item.OtherData;
    }

    let startPoint = new THREE.Vector3(
      drawData.startPoint.x,
      drawData.startPoint.y,
      0
    );
    let endPoint = new THREE.Vector3(
      drawData.endPoint.x,
      drawData.endPoint.y,
      0
    );
    if (isMirror) {
      startPoint = getMirroredPoint(sp, ep, startPoint);
      endPoint = getMirroredPoint(sp, ep, endPoint);
    } else {
      startPoint.add(vecMove);
      endPoint.add(vecMove);
    }
    otherData = {
      startPoint: {
        x: startPoint.x,
        y: startPoint.y,
        z: 0,
      },
      endPoint: {
        x: endPoint.x,
        y: endPoint.y,
        z: 0,
      },
    };
  }

  let newObj = new rlPartitionWallData();
  newObj.initData({
    m_sectParamData: item.m_sectParamData,
    Ecc: item.Ecc,
    Mat: item.Mat,
    partitionWallHeight: item.partitionWallHeight,
    LevelB: item.LevelB,
    m_gridData: gridObj,
    Color: item.Color,
    Attribute: item.Attribute,
    LinkGuids: item.LinkGuids,
    OtherData: otherData ? JSON.stringify(otherData) : item.OtherData,
  });

  newObj.draw();
  let existObj = await addEntityToDrawing(newObj);
  if (!existObj) {
    existObj = newObj;
  }
  return existObj;
};

//批量移动
export const MoveEntArray = async () => {
  createConfirmButton("move");

  Message.info("请选择要移动的实体");
  const getIds = async (ids) => {
    if (!ids.length) return;
    try {
      store.commit("cadModules/setSnapPoint", {
        snapPoint: null,
        needCatchSnap: true,
      });
      highlightEntityArray(ids, false);
      setIds(ids);
    } catch (error) {
      console.error("移动实体失败", error);
    }
  };
  //框选实体
  userSelect(getIds);
};

export const MoveEnts = async (ids) => {
  if (!ids.length) return;
  //过程预览
  let previewObjIds = [];
  const previewEnts = (ids, sp, ep) => {
    if (!ids.length) return;
    if (previewObjIds.length) {
      previewObjIds.forEach((id) => {
        let obj = id.getMcDbEntity();
        obj.move(
          new McGePoint3d(sp.x, sp.y, 0),
          new McGePoint3d(ep.x, ep.y, 0)
        );
      });
    } else {
      for (const id of ids) {
        let obj = id.getMcDbEntity().clone();
        obj.move(
          new McGePoint3d(sp.x, sp.y, 0),
          new McGePoint3d(ep.x, ep.y, 0)
        );
        previewObjIds.push(rlAppObj.mxcadObject.drawEntity(obj));
      }
    }
  };

  const move_fn = async (ids) => {
    if (!ids.length) return;
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: true,
    });
    highlightEntityArray(ids);

    //移动基点
    await new Promise((resolve) => {
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      let pt1 = null;
      let originalPoint = null;
      // 关闭正交模式
      fixOrthogonal(false);

      getPoint.setInputToucheType(1);
      Message.info("请选择基点");
      getPoint.go((status) => {
        if (status !== 0) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          clearEntityArrayHighlight();
          return;
        }
        store.commit("platBtns/SET_ISMOVEORCOPY", true);
        // 开启正交模式
        fixOrthogonal(true);
        pt1 = store.state.cadModules.snapPoint.snapPoint; //getPoint.value();

        if (!pt1) {
          pt1 = getPoint.value();
          // 启用捕捉优化
          let snapPoint = enableSnapCorrection(pt1, null, true);
          pt1 = snapPoint ? snapPoint : pt1;
        }

        getPoint.setBasePt(pt1);
        originalPoint = pt1;

        store.commit("cadModules/setSnapPoint", {
          snapPoint: null,
          needCatchSnap: false,
        });

        const mxcad = MxCpp.getCurrentMxCAD();
        mxcad.addDimStyle(
          "MoveDistDimStyle",
          "41,0.18,141,0.09,140,0,40,200",
          "77,1,271,3,73,1",
          "",
          ""
        );

        mxcad.drawDimStyle = "MoveDistDimStyle";
        let mDimensionId = mxcad.drawDimAligned(
          originalPoint.x,
          originalPoint.y,
          originalPoint.x,
          originalPoint.y,
          originalPoint.x,
          originalPoint.y
        );
        const mDimensionObj = mDimensionId.getMcDbEntity();
        //添加输入框
        let inputElement = getInputElement();
        if (!inputElement) {
          inputElement = createInputElement(mDimensionObj);
        } else {
          setCurrDataObj(mDimensionObj);
          // inputElement.style.display = "block";
          setContainerShow(true);
        }
        //设置输入框不能输入
        inputElement.readOnly = true;

        // 设置第一个点位置
        getPoint.setUserDraw((currentPoint) => {
          let snapPoint = enableSnapCorrection(
            currentPoint,
            originalPoint,
            true
          );
          currentPoint = snapPoint ? snapPoint : currentPoint;
          // const jointpoint = getMinDistJoint(currentPoint);
          const dx = currentPoint.x - pt1.x;
          const dy = currentPoint.y - pt1.y;
          const dz = 0;

          // 鼠标位置
          previewEnts(
            ids,
            new McGePoint3d(pt1.x, pt1.y, pt1.z),
            new McGePoint3d(pt1.x + dx, pt1.y + dy, pt1.z + dz)
          );
          // 更新 pt1 为 鼠标位置
          pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);

          mDimensionObj.xLine2Point = new McGePoint3d(
            currentPoint.x,
            currentPoint.y,
            currentPoint.z
          );
          const midX = (originalPoint.x + currentPoint.x) / 2;
          const midY = (originalPoint.y + currentPoint.y) / 2;
          mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);

          setInputElementPosition(
            originalPoint.distanceTo(currentPoint).toFixed(0),
            midX,
            midY
          );
        });

        Message.info("请选择终点");
        // 第二次点击鼠标
        getPoint.setInputToucheType(2);
        // while (true) {}
        getPoint.go((status2) => {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          if (status2 !== 0) {
            if (originalPoint) {
              // 移动回原始位置
              for (const id of previewObjIds) {
                id.getMcDbEntity().erase();
              }
              // 删除标注
              mDimensionObj.erase();
            }
            clearEntityArrayHighlight();
            store.commit("platBtns/SET_ISMOVEORCOPY", false);
            resolve();
            return;
          }

          //设置输入框可以输入
          inputElement.readOnly = false;

          // 获取最终点位置
          let finalPoint = pt1;
          // 鼠标位置
          previewEnts(
            ids,
            new McGePoint3d(pt1.x, pt1.y, pt1.z),
            new McGePoint3d(finalPoint.x, finalPoint.y, finalPoint.z)
          );

          // 计算移动的距离和角度
          const dx = finalPoint.x - originalPoint.x;
          const dy = finalPoint.y - originalPoint.y;
          const distance = Math.sqrt(dx * dx + dy * dy).toFixed(2);
          const angle = (Math.atan2(dy, dx) * (180 / Math.PI)).toFixed(2); // 转换为角度

          store.commit("cadModules/setMoveDistObj", {
            idArray: ids,
            distId: mDimensionId,
            previewObjIds: previewObjIds,
            st: new THREE.Vector3(originalPoint.x, originalPoint.y, 0),
            ed: new THREE.Vector3(finalPoint.x, finalPoint.y, 0),
            isMove: true, //是否移动,与批量复制区分
          });

          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识

          setTimeout(() => {
            clearEntityArrayHighlight();
            rlAppObj.rlMxDrawObject.updateDisplay();
          }, 200);
          resolve();
        });
      });
    });
  };
  await move_fn(ids);
  clearEntityArrayHighlight();
  rlAppObj._rlMx.MxFun.stopRunCommand();
};

//检查移动数据是否合理，若不合理，不能移动
const checkMoveData = (ids, sp, ep, isCopy, isMirror = false) => {
  try {
    if (ids.length === 0) {
      return true;
    }
    let modelData = {}; ///记录构件数据
    let moveGridDataArray = []; //记录网格数据
    for (const id of ids) {
      if (id) {
        let entData = getEntityById(id);
        if (entData) {
          if (
            entData.m_gridData &&
            !moveGridDataArray.find(
              (item) => item.Guid === entData.m_gridData.Guid
            )
          ) {
            moveGridDataArray.push(entData.m_gridData);
          } else if (
            entData.classTypeName === "rlGrid" &&
            !moveGridDataArray.find((item) => item.Guid === entData.Guid)
          ) {
            moveGridDataArray.push(entData);
          }
          if (entData.ModelType) {
            if (!modelData[entData.classTypeName]) {
              modelData[entData.classTypeName] = [];
            }
            modelData[entData.classTypeName].push(entData);
          }
        }
      }
    }

    const vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0);
    if (modelData["rlColSeg"]) {
      const totalJointData = store.state.rlEntData.totalEntityData["rlJoint"];
      let ignoreJointArray = []; //获取存在于画布且不存在于移动数据中的节点
      for (const existJoint of totalJointData) {
        if (
          modelData["rlColSeg"].find(
            (item) => item.m_JointData.Guid == existJoint.Guid
          )
        ) {
          ignoreJointArray.push(existJoint);
        }
      }

      for (const item of modelData["rlColSeg"]) {
        //判断新位置是否有节点
        const newPt = new THREE.Vector3(...item.m_JointData.m_pt)
          .add(vecMove)
          .toArray();

        const jointData = JointIsExist(newPt, ignoreJointArray);
        if (jointData && jointData.m_cloumId) {
          return false;
        }
      }
    }

    let modelArray = [];
    if (
      modelData["rlBeamSeg"] ||
      modelData["rlWallSeg"] ||
      modelData["rlPartitionWallSeg"]
    ) {
      if (modelData["rlBeamSeg"]) {
        modelArray.push(...modelData["rlBeamSeg"]);
      }
      if (modelData["rlWallSeg"]) {
        modelArray.push(...modelData["rlWallSeg"]);
      }
      if (modelData["rlPartitionWallSeg"]) {
        modelArray.push(
          ...modelData["rlPartitionWallSeg"].filter(
            (wall) => wall.m_gridData != null
          )
        );
      }
    }

    const totalGridData = store.state.rlEntData.totalEntityData["rlGrid"];
    let calGridData = []; //获取存在于画布且不存在于移动数据中的网格
    for (const existGrid of totalGridData) {
      if (
        isCopy ||
        !moveGridDataArray.find((item) => item && item.Guid == existGrid.Guid)
      ) {
        calGridData.push(existGrid);
      }
    }

    for (const moveGrid of moveGridDataArray) {
      if (!moveGrid || !moveGrid.m_stJoint || !moveGrid.m_edJoint) {
        continue;
      }

      const newPtSt = isMirror
        ? getMirroredPoint(
            sp,
            ep,
            new THREE.Vector3(...moveGrid.m_stJoint.m_pt)
          )
        : new THREE.Vector3(...moveGrid.m_stJoint.m_pt).add(vecMove);
      const newPtEd = isMirror
        ? getMirroredPoint(
            sp,
            ep,
            new THREE.Vector3(...moveGrid.m_edJoint.m_pt)
          )
        : new THREE.Vector3(...moveGrid.m_edJoint.m_pt).add(vecMove);

      let isArc = moveGrid.m_centerJoint != null;
      const centerPoint = isArc
        ? isMirror
          ? getMirroredPoint(
              sp,
              ep,
              new THREE.Vector3(...moveGrid.m_centerJoint.m_pt)
            )
          : new THREE.Vector3(...moveGrid.m_centerJoint.m_pt).add(vecMove)
        : null;

      for (const existGrid of calGridData) {
        if (!isCopy && existGrid.Guid === moveGrid.Guid) {
          continue;
        }

        const isArcTmp = existGrid.m_centerJoint != null;
        const ptSt = new THREE.Vector3(...existGrid.m_stJoint.m_pt);
        const ptEd = new THREE.Vector3(...existGrid.m_edJoint.m_pt);
        const centerPointTmp = isArcTmp
          ? new THREE.Vector3(...existGrid.m_centerJoint.m_pt)
          : null;

        //判断移动网格是否与画布中网格相交打断
        if (isArc && isArcTmp) {
          const insertRes = arcArcIntersection1(
            centerPoint,
            newPtSt,
            newPtEd,
            centerPointTmp,
            ptSt,
            ptEd
          );
          if (insertRes.isIntersected) {
            return false;
          }
        } else if (isArc || isArcTmp) {
          if (isArc) {
            const insertRes = lineArcIntersection1(
              ptSt,
              ptEd,
              centerPoint,
              newPtSt,
              newPtEd
            );
            if (insertRes.isIntersected) {
              return false;
            }
          } else {
            const insertRes = lineArcIntersection1(
              newPtSt,
              newPtEd,
              centerPointTmp,
              ptSt,
              ptEd
            );
            if (insertRes.isIntersected) {
              return false;
            }
          }
        } else {
          const insertRes = lineInsection(ptSt, ptEd, newPtSt, newPtEd, true);
          if (insertRes.isIntersected) {
            lineInsection(ptSt, ptEd, newPtSt, newPtEd, true); //用于错误调试
            return false;
          }
        }

        if (isArc != isArcTmp) {
          continue;
        }

        if (
          (moveGrid.m_wallId && !existGrid.m_wallId) ||
          (moveGrid.m_beamId && !existGrid.m_beamId) ||
          (moveGrid.m_partitionWallId && !existGrid.m_partitionWallId)
        ) {
          //判断是否重叠
          if (
            (ptIsEqual(newPtSt, ptSt) && ptIsEqual(newPtEd, ptEd)) ||
            (ptIsEqual(newPtSt, ptEd) && ptIsEqual(newPtEd, ptSt))
          ) {
            continue;
          }
        }

        //判断新的网格是否与原网格重叠/部分重叠
        if (isArc) {
          if (centerPoint.distanceTo(centerPointTmp) < 1) {
            if (
              isArcsOverlapping(
                centerPoint,
                newPtSt,
                newPtEd,
                centerPointTmp,
                ptSt,
                ptEd
              )
            ) {
              return false;
            }
          }
        } else {
          if (isLinesOverlapping(newPtSt, newPtEd, ptSt, ptEd)) {
            isLinesOverlapping(newPtSt, newPtEd, ptSt, ptEd); //用于错误调试
            return false;
          }
        }
      }
    }

    // for (const modelObj of modelArray) {
    //   if (!modelObj.m_gridData) continue;

    //   const newPtSt = new THREE.Vector3(
    //     ...modelObj.m_gridData.m_stJoint.m_pt
    //   ).add(vecMove);
    //   const newPtEd = new THREE.Vector3(
    //     ...modelObj.m_gridData.m_edJoint.m_pt
    //   ).add(vecMove);
    //   // const newGridLine = new THREE.Line3(newPtSt, newPtEd);

    //   const isArc = modelObj.m_gridData.m_centerJoint != null;
    //   for (const existGrid of calGridData) {
    //     if (existGrid.Guid === modelObj.m_gridData.Guid) {
    //       continue;
    //     }

    //     // if (!modelObj.m_gridData.m_wallId || !existGrid.m_wallId) {
    //     //   if (!modelObj.m_gridData.m_beamId || !existGrid.m_beamId) {
    //     //     if (
    //     //       !modelObj.m_gridData.m_partitionWallId ||
    //     //       !existGrid.m_partitionWallId
    //     //     )
    //     //       continue;
    //     //   }
    //     // }

    //     const isArcTmp = existGrid.m_centerJoint != null;
    //     const ptSt = new THREE.Vector3(...existGrid.m_stJoint.m_pt);
    //     const ptEd = new THREE.Vector3(...existGrid.m_edJoint.m_pt);

    //     if (isArc != isArcTmp) {
    //       continue;
    //     }

    //     if (
    //       (modelObj.m_gridData.m_wallId && !existGrid.m_wallId) ||
    //       (modelObj.m_gridData.m_beamId && !existGrid.m_beamId) ||
    //       (modelObj.m_gridData.m_partitionWallId &&
    //         !existGrid.m_partitionWallId)
    //     ) {
    //       //判断是否重叠
    //       if (
    //         (ptIsEqual(newPtSt, ptSt) && ptIsEqual(newPtEd, ptEd)) ||
    //         (ptIsEqual(newPtSt, ptEd) && ptIsEqual(newPtEd, ptSt))
    //       ) {
    //         continue;
    //       }
    //     }

    //     //判断新的网格是否与原网格重叠/部分重叠
    //     if (isArc) {
    //       //to do...
    //       let centerPoint = new THREE.Vector3(
    //         ...modelObj.m_gridData.m_centerJoint.m_pt
    //       );
    //       let centerPointTmp = new THREE.Vector3(
    //         ...existGrid.m_centerJoint.m_pt
    //       );
    //       if (centerPoint.distanceTo(centerPointTmp) < 1) {
    //         if (
    //           isArcsOverlapping(
    //             centerPoint,
    //             newPtSt,
    //             newPtEd,
    //             centerPointTmp,
    //             ptSt,
    //             ptEd
    //           )
    //         ) {
    //           return false;
    //         }
    //       }
    //     } else {
    //       if (isLinesOverlapping(newPtSt, newPtEd, ptSt, ptEd)) {
    //         return false;
    //       }
    //     }
    //   }
    // }

    // if (modelData["rlSlab"]) {
    //   const totalSlabData = store.state.rlEntData.totalEntityData["rlSlab"];
    //   let slabPolyLineData = [];
    //   for (const slab of totalSlabData) {
    //     if (modelData["rlSlab"].find((obj) => obj.Guid == slab.Guid)) {
    //       continue;
    //     }
    //     const VertexX = slab.VertexX.split(",");
    //     const VertexY = slab.VertexY.split(",");
    //     const VertexZ = slab.VertexZ.split(",");
    //     let points = [];
    //     for (let i = 0; i < VertexX.length; i++) {
    //       points.push(
    //         new THREE.Vector3(
    //           Number(VertexX[i]),
    //           Number(VertexY[i]),
    //           Number(VertexZ[i])
    //         )
    //       );
    //     }
    //     slabPolyLineData.push(points);
    //   }

    //   for (const item of modelData["rlSlab"]) {
    //     const VertexX = item.VertexX.split(",");
    //     const VertexY = item.VertexY.split(",");
    //     const VertexZ = item.VertexZ.split(",");
    //     let points = [];
    //     for (let i = 0; i < VertexX.length; i++) {
    //       let newPt=new THREE.Vector3(
    //         Number(VertexX[i]),
    //         Number(VertexY[i]),
    //         Number(VertexZ[i]));
    //       newPt.add(vecMove);
    //       points.push(newPt);
    //     }

    //     for (let i = 0; i < slabPolyLineData.length; i++) {
    //       const pointsTmp = slabPolyLineData[i];
    //       //判断轮廓线是否相交或重叠
    //       const isIntersect = checkContoursIntersection(points, pointsTmp);
    //       if (isIntersect) {
    //         return false;
    //       }
    //     }
    //   }
    // }

    return true;
  } catch (error) {
    console.log("移动检查出错", error);
  }
};

export const moveEnts = async (ids, sp, ep) => {
  try {
    if (ids.length == 0 || ptIsEqual(sp, ep)) {
      return;
    }

    if (!checkMoveData(ids, sp, ep, false)) {
      Message.warning("移动后会造成构件重叠，请重新选择移动数据及移动落点");
      store.commit("globalData/setCanAddRawStep", false); //删除撤销步数
      return;
    }

    //获取移动数据
    const getMoveData = (ids) => {
      let moveData = {}; //移动数据
      let copyData = []; //复制数据
      let errorData = []; //错误数据--目前只存在楼板数据，因为楼板需要关联多条网格

      let totalEntDatas = {}; //所有实体数据按类型分类
      for (const id of ids) {
        if (id) {
          let entData = getEntityById(id);
          if (entData) {
            if (!totalEntDatas[entData.classTypeName]) {
              totalEntDatas[entData.classTypeName] = [];
            }
            if (
              totalEntDatas[entData.classTypeName].find(
                (item) => item.Guid == entData.Guid
              )
            ) {
              continue;
            }
            totalEntDatas[entData.classTypeName].push(entData);
          }
        }
      }

      //原本节点有关联数据不需要移动时，复制节点,否则移动节点
      if (totalEntDatas["rlJoint"]) {
        for (const item of totalEntDatas["rlJoint"]) {
          //判断关联数据是否存在于totalEntDatas中
          let isCopy = false;

          let gridIds = item.m_gridIds;
          for (const gridId of gridIds) {
            if (
              !totalEntDatas["rlGrid"] ||
              !totalEntDatas["rlGrid"].filter((grid) => grid.Guid == gridId)
                .length
            ) {
              isCopy = true;
              break;
            }
          }

          if (!isCopy) {
            let linkColumnId = item.m_cloumId;
            if (
              linkColumnId &&
              (!totalEntDatas["rlColSeg"] ||
                !totalEntDatas["rlColSeg"].filter(
                  (column) => column.Guid == linkColumnId
                ).length)
            ) {
              isCopy = true;
            }
          }

          if (isCopy) {
            copyData.push(item.mcDbId);
          } else {
            if (!moveData["rlJoint"]) {
              moveData["rlJoint"] = [];
            }
            moveData["rlJoint"].push(item);
          }
        }
      }

      //原本网格有关联数据时，复制网格,否则移动网格
      if (totalEntDatas["rlGrid"]) {
        for (const item of totalEntDatas["rlGrid"]) {
          //判断网格附属的节点数据是需要新增
          if (item.m_centerJoint) {
            if (
              !totalEntDatas["rlJoint"] ||
              !totalEntDatas["rlJoint"].find(
                (joint) => joint.Guid == item.m_centerJoint.Guid
              )
            ) {
              if (
                !item.m_centerJoint.m_cloumId &&
                item.m_centerJoint.m_gridIds.length == 1
              ) {
                if (!moveData["rlJoint"]) {
                  moveData["rlJoint"] = [];
                }
                //节点为孤立节点，跟随移动
                moveData["rlJoint"].push(item.m_centerJoint);
              } else {
                copyData.push(item.m_centerJoint.mcDbId);
              }
            }
          }
          if (
            !totalEntDatas["rlJoint"] ||
            !totalEntDatas["rlJoint"].find(
              (joint) => joint.Guid == item.m_stJoint.Guid
            )
          ) {
            if (
              !item.m_stJoint.m_cloumId &&
              item.m_stJoint.m_gridIds.length == 1
            ) {
              if (!moveData["rlJoint"]) {
                moveData["rlJoint"] = [];
              }
              //节点为孤立节点，跟随移动
              moveData["rlJoint"].push(item.m_stJoint);
            } else {
              copyData.push(item.m_stJoint.mcDbId);
            }
          }

          //判断网格附属的节点数据是需要移动
          if (
            !totalEntDatas["rlJoint"] ||
            !totalEntDatas["rlJoint"].find(
              (joint) => joint.Guid == item.m_edJoint.Guid
            )
          ) {
            if (
              !item.m_edJoint.m_cloumId &&
              item.m_edJoint.m_gridIds.length == 1
            ) {
              if (!moveData["rlJoint"]) {
                moveData["rlJoint"] = [];
              }
              //节点为孤立节点，跟随移动
              moveData["rlJoint"].push(item.m_edJoint);
            } else {
              copyData.push(item.m_edJoint.mcDbId);
            }
          }

          //判断关联数据是否存在于totalEntDatas中，若存在部分不在totalEntDatas中，则网格需要复制
          let isCopy = false;
          if (
            item.m_beamId &&
            (!totalEntDatas["rlBeamSeg"] ||
              !totalEntDatas["rlBeamSeg"].filter(
                (beam) => beam.Guid == item.m_beamId
              ).length)
          ) {
            isCopy = true;
          }
          if (
            item.m_wallId &&
            !isCopy &&
            totalEntDatas["rlWallSeg"] &&
            !totalEntDatas["rlWallSeg"].filter(
              (wall) => wall.Guid == item.m_wallId
            ).length
          ) {
            isCopy = true;
          }
          if (
            item.m_ringBeamId &&
            !isCopy &&
            totalEntDatas["rlRingBeamSeg"] &&
            !totalEntDatas["rlRingBeamSeg"].filter(
              (beam) => beam.Guid == item.m_ringBeamId
            ).length
          ) {
            isCopy = true;
          }

          // let slabIds = item.m_slabIds;
          // for (const slabId of slabIds) {
          //   if (
          //     totalEntDatas["rlSlab"] &&
          //     !totalEntDatas["rlSlab"].find((slab) => slab.Guid == slabId)
          //   ) {
          //     errorData.push(slabId);
          //   }
          // }

          if (
            item.m_partitionWallId &&
            !isCopy &&
            totalEntDatas["rlPartitionWallSeg"] &&
            !totalEntDatas["rlPartitionWallSeg"].filter(
              (partitionWall) =>
                partitionWall.m_gridData &&
                partitionWall.Guid == item.m_partitionWallId
            ).length
          ) {
            isCopy = true;
          }
          if (!isCopy) {
            if (!moveData["rlGrid"]) {
              moveData["rlGrid"] = [];
            }
            moveData["rlGrid"].push(item);
          } else {
            copyData.push(item.mcDbId);
          }
        }
      }

      //框选的柱都是移动数据，除非关联的节点数据不存在
      if (totalEntDatas["rlColSeg"]) {
        for (const item of totalEntDatas["rlColSeg"]) {
          if (
            totalEntDatas["rlJoint"] &&
            totalEntDatas["rlJoint"].find(
              (joint) => joint.Guid == item.m_JointData.Guid
            )
          ) {
            if (!moveData["rlColSeg"]) {
              moveData["rlColSeg"] = [];
            }
            moveData["rlColSeg"].push(item);
          }
        }
      }
      //框选的梁都是移动数据，除非关联的网格数据不存在
      if (totalEntDatas["rlBeamSeg"]) {
        for (const item of totalEntDatas["rlBeamSeg"]) {
          if (
            totalEntDatas["rlGrid"] &&
            totalEntDatas["rlGrid"].find(
              (grid) => grid.Guid == item.m_gridData.Guid
            )
          ) {
            continue;
          }
          if (!moveData["rlBeamSeg"]) {
            moveData["rlBeamSeg"] = [];
          }
          moveData["rlBeamSeg"].push(item);
        }
      }

      //框选的墙都是移动数据，除非关联的网格数据不存在
      if (totalEntDatas["rlWallSeg"]) {
        for (const item of totalEntDatas["rlWallSeg"]) {
          if (
            totalEntDatas["rlGrid"] &&
            totalEntDatas["rlGrid"].find(
              (grid) => grid.Guid == item.m_gridData.Guid
            )
          ) {
            if (!moveData["rlWallSeg"]) {
              moveData["rlWallSeg"] = [];
            }
            moveData["rlWallSeg"].push(item);
          }
        }
      }

      //框选的楼板都是移动数据，除非关联的网格数据不存在
      if (totalEntDatas["rlSlab"]) {
        for (const item of totalEntDatas["rlSlab"]) {
          if (!moveData["rlSlab"]) {
            moveData["rlSlab"] = [];
          }
          moveData["rlSlab"].push(item);
          // continue;
          let GridsGuid = item.GridsGuid;
          let GridsGuidArray = GridsGuid.split(",");
          let isMove = true;
          let isError = false;
          for (const gridGuid of GridsGuidArray) {
            if (!gridGuid) {
              continue;
            }
            if (
              totalEntDatas["rlGrid"] &&
              !totalEntDatas["rlGrid"].find((grid) => grid.Guid == gridGuid)
            ) {
              isMove = false;
            } else {
              isError = true;
            }
          }

          if (isMove) {
            // if (!moveData["rlSlab"]) {
            //   moveData["rlSlab"] = [];
            // }
            // moveData["rlSlab"].push(item);
          } else if (!isMove && isError) {
            errorData.push(item.Guid);
          }
        }
      }

      //框选的隔墙都是移动数据，除非关联的网格数据不存在
      if (totalEntDatas["rlPartitionWallSeg"]) {
        for (const item of totalEntDatas["rlPartitionWallSeg"]) {
          if (item.m_gridData) {
            if (
              totalEntDatas["rlGrid"] &&
              totalEntDatas["rlGrid"].find(
                (grid) => grid.Guid == item.m_gridData.Guid
              )
            ) {
              if (!moveData["rlPartitionWallSeg"]) {
                moveData["rlPartitionWallSeg"] = [];
              }
              moveData["rlPartitionWallSeg"].push(item);
            }
          } else {
            if (!moveData["rlPartitionWallSeg"]) {
              moveData["rlPartitionWallSeg"] = [];
            }
            moveData["rlPartitionWallSeg"].push(item);
          }
        }
      }

      //框选的墙洞都是移动数据，除非关联的墙数据不存在
      if (totalEntDatas["rlWallHole"]) {
        for (const item of totalEntDatas["rlWallHole"]) {
          if (item.m_gridData) {
            if (
              totalEntDatas["rlWallSeg"] &&
              totalEntDatas["rlWallSeg"].find(
                (wall) => wall.Guid == item.m_gridData.m_wallId
              )
            ) {
              if (!moveData["rlWallHole"]) {
                moveData["rlWallHole"] = [];
              }
              moveData["rlWallHole"].push(item);
            } else if (
              totalEntDatas["rlPartitionWallSeg"] &&
              !totalEntDatas["rlPartitionWallSeg"].find(
                (partitionWall) => partitionWall.Guid == item.m_gridData.Guid
              ).length
            ) {
              if (!moveData["rlWallHole"]) {
                moveData["rlWallHole"] = [];
              }
              moveData["rlWallHole"].push(item);
            }
          }
        }
      }

      //框选的门窗都是移动数据，除非关联的隔墙数据不存在
      // if (totalEntDatas["rlDoorsWindows"]) {
      //   for (const item of totalEntDatas["rlDoorsWindows"]) {
      //     if (item.m_partitionWallData) {
      //       if (
      //         !totalEntDatas["rlPartitionWallSeg"].find(
      //           (partitionWall) =>
      //             partitionWall.Guid == item.m_partitionWallData.Guid
      //         )
      //       ) {
      //         continue;
      //       }
      //     }
      //     if (!moveData["rlDoorsWindows"]) {
      //       moveData["rlDoorsWindows"] = [];
      //     }
      //     moveData["rlDoorsWindows"].push(item);
      //   }
      // }

      //框选的门窗都是移动数据，除非关联的构件数据不存在
      if (totalEntDatas["rlUse"]) {
        for (const item of totalEntDatas["rlUse"]) {
          let allEntGuids = item.allEntGuids;

          let isMove = true;
          //遍历allEntGuids对象
          for (const entGuid in allEntGuids) {
            if (entGuid.beamGuids && entGuid.beamGuids.length > 0) {
              for (const beamGuid of entGuid.beamGuids) {
                if (
                  totalEntDatas["rlBeamSeg"].find(
                    (beam) => beam.Guid == beamGuid
                  )
                ) {
                  continue;
                } else {
                  isMove = false;
                  break;
                }
              }
            }
            if (!isMove) {
              break;
            }
            if (entGuid.columnGuids && entGuid.columnGuids.length > 0) {
              for (const columnGuid of entGuid.columnGuids) {
                if (
                  totalEntDatas["rlColSeg"].find(
                    (column) => column.Guid == columnGuid
                  )
                ) {
                  continue;
                } else {
                  isMove = false;
                  break;
                }
              }
            }
            if (!isMove) {
              break;
            }
            if (
              entGuid.partitionWallGuids &&
              entGuid.partitionWallGuids.length > 0
            ) {
              for (const partitionWallGuid of entGuid.partitionWallGuids) {
                if (
                  totalEntDatas["rlPartitionWallSeg"].find(
                    (partitionWall) => partitionWall.Guid == partitionWallGuid
                  )
                ) {
                  continue;
                } else {
                  isMove = false;
                  break;
                }
              }
            }
            if (!isMove) {
              break;
            }
            if (entGuid.slabGuids && entGuid.slabGuids.length > 0) {
              for (const slabGuid of entGuid.slabGuids) {
                if (
                  totalEntDatas["rlSlab"].find((slab) => slab.Guid == slabGuid)
                ) {
                  continue;
                } else {
                  isMove = false;
                  break;
                }
              }
            }
            if (entGuid.wallGuids && entGuid.wallGuids.length > 0) {
              for (const wallGuid of entGuid.wallGuids) {
                if (
                  totalEntDatas["rlWallSeg"].find(
                    (wall) => wall.Guid == wallGuid
                  )
                ) {
                  continue;
                } else {
                  isMove = false;
                  break;
                }
              }
            }
          }
          if (isMove) {
            if (!moveData["rlUse"]) {
              moveData["rlUse"] = [];
            }
            moveData["rlUse"].push(item);
          }
        }
      }

      //悬挑板数据
      if (totalEntDatas["rlCantiSlab"]) {
        for (const item of totalEntDatas["rlCantiSlab"]) {
          if (item.m_gridData) {
            if (
              totalEntDatas["rlGrid"] &&
              totalEntDatas["rlGrid"].find(
                (grid) => grid.Guid == item.m_gridData.Guid
              )
            ) {
              if (!moveData["rlCantiSlab"]) {
                moveData["rlCantiSlab"] = [];
              }
              moveData["rlCantiSlab"].push(item);
            }
          }
        }
      }

      //板洞数据
      if (totalEntDatas["rlSlabHole"]) {
        for (const item of totalEntDatas["rlSlabHole"]) {
          if (item.m_JointData && item.m_SlabData) {
            if (
              totalEntDatas["rlSlab"] &&
              totalEntDatas["rlSlab"].find(
                (slab) => slab.Guid == item.m_SlabData.Guid
              ) &&
              totalEntDatas["rlJoint"] &&
              totalEntDatas["rlJoint"].find(
                (joint) => joint.Guid == item.m_JointData.Guid
              )
            ) {
              if (!moveData["rlSlabHole"]) {
                moveData["rlSlabHole"] = [];
              }
              moveData["rlSlabHole"].push(item);
            }
          }
        }
      }

      return { moveData, copyData, errorData };
    };

    //获取移动数据
    const { moveData, copyData, errorData } = getMoveData(ids);
    // console.log("moveData111", moveData, copyData);

    // 绘制步数
    // store.commit("globalData/setCanAddRawStep", true);
    // if (errorData.length > 0) {
    //   let withJcData = [];
    //   let errorDataArray = [];
    //   for (const item of errorData) {
    //     let res = await getDelText([item]);
    //     let errorDataObj = getEntityData({
    //       classTypeName: "rlSlab",
    //       Guid: item,
    //     });
    //     if (errorDataObj) {
    //       errorDataArray.push(errorDataObj);
    //       if (res) {
    //         withJcData.push(item.Guid);
    //         errorDataObj.mcDbId.getMcDbEntity().highlight = true;
    //       }
    //     }
    //   }
    //   const type = await VXETable.modal.confirm(
    //     withJcData.length > 0
    //       ? "存在楼板数据将被删除，部分构件检测数据已录,请确认是否删除"
    //       : "存在楼板数据将被删除，请确认是否删除"
    //   );
    //   if (type === "confirm") {
    //     for (const item of errorDataArray) {
    //       item.erase();
    //     }
    //   } else {
    //     // 用户取消操作，返回false表示操作被取消
    //     return false;
    //   }
    // }

    let vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0);
    const copyRes = await copyEnts(copyData, sp, ep, false, false);
    // console.log("copyRes", copyRes);

    let newJointData = {};
    if (moveData["rlJoint"]) {
      for (const item of moveData["rlJoint"]) {
        let isCopy = false;
        if (copyRes) {
          for (const key in copyRes) {
            if (copyRes[key].Guid === item.Guid) {
              isCopy = true;
              break;
            }
          }
          if (isCopy) {
            //复制后的节点刚好在待移动的点上，所以该移动点需要复制
            const newObj = await copyJointData(
              new THREE.Vector3(...item.m_pt).add(vecMove),
              item.HDiff
            );
            copyRes[item.Guid] = newObj;
            //从 moveData["rlJoint"]中移除item数据
            moveData["rlJoint"] = moveData["rlJoint"].filter(
              (jt) => jt.Guid !== item.Guid
            );
            if (
              item.m_cloumId &&
              moveData["rlColSeg"] &&
              moveData["rlColSeg"].find((col) => col.Guid == item.m_cloumId)
            ) {
              let colObj = getEntityData({
                classTypeName: "rlColSeg",
                Guid: item.m_cloumId,
              });
              if (colObj) {
                colObj.saveEditRevokeData();
                colObj.m_JointData = newObj;
                colObj.updateThisObj(colObj);
              }
            }
            continue;
          }
        }
        //判断节点是否已存在
        let ptNew = new THREE.Vector3(...item.m_pt).add(vecMove).toArray();
        let existJoint = JointIsExist(ptNew);

        if (
          !existJoint ||
          moveData["rlJoint"].find((jt) => jt.Guid == existJoint.Guid)
        ) {
          item.saveEditRevokeData();
          item.m_pt = ptNew;
          const onGrids = JointIsOnGrid(ptNew, moveData["rlGrid"] || []);

          if (onGrids && onGrids.length) {
            for (const obj of onGrids) {
              if (obj) {
                // 切分网格
                await jointCutGrid(item, obj, moveData["rlGrid"] || []);
              }
            }
          }

          item.updateThisObj(item, false);
        } else {
          newJointData[item.Guid] = existJoint;
          if (
            item.m_cloumId &&
            moveData["rlColSeg"] &&
            moveData["rlColSeg"].find((col) => col.Guid == item.m_cloumId)
          ) {
            let colObj = getEntityData({
              classTypeName: "rlColSeg",
              Guid: item.m_cloumId,
            });
            if (colObj) {
              colObj.saveEditRevokeData();
              colObj.m_JointData = existJoint;
              colObj.updateThisObj(colObj);
            }
          }
          // item.m_AxisIds = [];
          // item.m_gridIds = [];
          item.m_cloumId = null;
        }
      }
    }

    // return;
    if (moveData["rlGrid"]) {
      for (const item of moveData["rlGrid"]) {
        let existGrid = GridIsExist(item, moveData["rlGrid"]);
        if (existGrid) {
          existGrid.m_beamId = item.m_beamId;
          existGrid.m_wallId = item.m_wallId;
          existGrid.m_ringBeamId = item.m_ringBeamId;
          existGrid.m_partitionWallId = item.m_partitionWallId;
          item.erase();

          continue;
        }

        //不够严谨，需完善
        item.saveEditRevokeData();
        if (item.m_centerJoint) {
          if (newJointData && newJointData[item.m_centerJoint.Guid]) {
            item.m_centerJoint = newJointData[item.m_centerJoint.Guid];
          } else if (
            moveData &&
            moveData["rlJoint"] &&
            moveData["rlJoint"].find(
              (joint) => joint.Guid == item.m_centerJoint.Guid
            )
          ) {
          } else if (copyRes && copyRes[item.m_centerJoint.Guid]) {
            item.m_centerJoint = copyRes[item.m_centerJoint.Guid];
          } else continue;
        }

        if (newJointData && newJointData[item.m_stJoint.Guid]) {
          item.m_stJoint = newJointData[item.m_stJoint.Guid];
        } else if (
          moveData &&
          moveData["rlJoint"] &&
          moveData["rlJoint"].find((joint) => joint.Guid == item.m_stJoint.Guid)
        ) {
        } else if (copyRes && copyRes[item.m_stJoint.Guid]) {
          item.m_stJoint = copyRes[item.m_stJoint.Guid];
        } //else continue;

        if (newJointData && newJointData[item.m_edJoint.Guid]) {
          item.m_edJoint = newJointData[item.m_edJoint.Guid];
        } else if (
          moveData &&
          moveData["rlJoint"] &&
          moveData["rlJoint"].find((joint) => joint.Guid == item.m_edJoint.Guid)
        ) {
        } else if (copyRes && copyRes[item.m_edJoint.Guid]) {
          item.m_edJoint = copyRes[item.m_edJoint.Guid];
        } //else continue;

        // console.log("item", item.m_stJoint.Guid, item.m_edJoint.Guid);

        item.updateThisObj(item);

        if (item.m_centerJoint) {
        } else {
          // const m_beamId = item.m_beamId;
          // const m_wallId = item.m_wallId;
          // const m_wallHoleId = item.m_wallHoleId;
          // const m_ringBeamId = item.m_ringBeamId;
          // let grid = new rlGridData();
          // grid.initData({
          //   m_stJoint: item.m_stJoint,
          //   m_edJoint: item.m_edJoint,
          //   StdFlrGuid: item.StdFlrGuid,
          //   m_Axis: null,
          // });
          // grid.m_beamId = item.m_beamId;
          // grid.m_wallId = item.m_wallId;
          // grid.m_ringBeamId = item.m_ringBeamId;
          // grid.m_partitionWallId = item.m_partitionWallId;
          // store.commit("rlEntData/delEntityData", {
          //   Guid: item.Guid,
          //   classTypeName: item.classTypeName,
          // });
          // let res = await addEntityToDrawing(grid);
          // console.log("res", res);
          // item.m_beamId = null;
          // item.m_wallId = null;
          // item.m_ringBeamId = null;
          // item.m_partitionWallId = null;
          // item.m_slabIds = null;
          // item.m_wallHoleIds = null;
          // item.m_useIds = null;
          // item.erase();
          // debugger;
          // if (m_beamId) {
          //   const objtmpBeam = getEntityData({
          //     Guid: m_beamId,
          //     classTypeName: "rlBeamSeg",
          //   });
          //   if (objtmpBeam) {
          //     objtmpBeam.saveEditRevokeData();
          //     objtmpBeam.m_gridData = grid;
          //     objtmpBeam.updateThisObj(objtmpBeam);
          //   }
          // }
        }

        // await gridLineInsertWith(item, false); //处理与其他网格相交
        // item.erase();
      }
    }

    if (moveData["rlColSeg"]) {
      for (const item of moveData["rlColSeg"]) {
        item.saveEditRevokeData();
        if (copyRes && copyRes[item.m_JointData.Guid]) {
          item.m_JointData.m_cloumId = null;
          item.m_JointData = copyRes[item.m_JointData.Guid];
        }
        item.updateThisObj(item);
      }
    }

    if (moveData["rlBeamSeg"]) {
      for (const item of moveData["rlBeamSeg"]) {
        item.saveEditRevokeData();
        if (copyRes && copyRes[item.m_gridData.Guid]) {
          item.m_gridData.m_beamId = null;
          item.m_gridData = copyRes[item.m_gridData.Guid];
        }
        item.updateThisObj(item);
      }
    }

    if (moveData["rlWallSeg"]) {
      for (const item of moveData["rlWallSeg"]) {
        item.saveEditRevokeData();
        if (copyRes && copyRes[item.m_gridData.Guid]) {
          item.m_gridData.m_wallId = null;
          item.m_gridData = copyRes[item.m_gridData.Guid];
        }

        item.updateThisObj(item, true, vecMove);
      }
    }

    if (moveData["rlSlab"]) {
      for (const item of moveData["rlSlab"]) {
        item.saveEditRevokeData();
        let VertexX = item.VertexX.split(",");
        let VertexY = item.VertexY.split(",");
        let VertexZ = item.VertexZ.split(",");
        //删除VertexX,VertexY,VertexZ中的空字符串
        VertexX = VertexX.filter((item) => item != "");
        VertexY = VertexY.filter((item) => item != "");
        VertexZ = VertexZ.filter((item) => item != "");

        //将VertexX,VertexY,VertexZ转换为数组
        VertexX = VertexX.map(Number);
        VertexY = VertexY.map(Number);
        VertexZ = VertexZ.map(Number);

        for (let i = 0; i < VertexX.length; i++) {
          VertexX[i] += vecMove.x;
          VertexY[i] += vecMove.y;
        }

        item.VertexX = VertexX.join(",");
        item.VertexY = VertexY.join(",");
        item.VertexZ = VertexZ.join(",");
        item.updateThisObj(item);
      }
    }

    //处理不移动的楼板与网格的关联关系--解绑网格
    const totalSlab = store.state.rlEntData.totalEntityData["rlSlab"];
    for (const item of totalSlab) {
      if (
        moveData["rlSlab"] &&
        moveData["rlSlab"].find((slab) => slab.Guid == item.Guid)
      ) {
        continue;
      }
      if (moveData["rlGrid"]) {
        //moveData["rlGrid"]与item.gridsObjs是否存在交集
        const gridsGuidArray = item.GridsGuid.split(",");
        const gridsGuidArray_1 = moveData["rlGrid"].map((grid) => grid.Guid);
        const isIntersect = gridsGuidArray.filter((guid) =>
          gridsGuidArray_1.includes(guid)
        );

        if (isIntersect && isIntersect.length > 0) {
          errorData.push(item.Guid);
          item.saveEditRevokeData();
          for (const grid of item.gridsObjs) {
            if (isIntersect.includes(grid.Guid)) {
              grid.m_slabIds = grid.m_slabIds.filter(
                (slabId) => slabId != item.Guid
              );
            }
          }
          item.gridsObjs = item.gridsObjs.filter(
            (grid) => !isIntersect.includes(grid.Guid)
          );
          item.GridsGuid = item.gridsObjs.map((grid) => grid.Guid).join(",");
          item.updateThisObj(item);
          continue;
        }
      }
    }

    //隔墙
    if (moveData["rlPartitionWallSeg"]) {
      for (const item of moveData["rlPartitionWallSeg"]) {
        if (item.m_gridData) {
          item.saveEditRevokeData();
          if (copyRes && copyRes[item.m_gridData.Guid]) {
            item.m_gridData.m_partitionWallId = null;
            item.m_gridData = copyRes[item.m_gridData.Guid];
          }
          item.updateThisObj(item, true, vecMove);
        } else if (item.OtherData) {
          item.saveEditRevokeData();
          let drawData = null;
          if (typeof item.OtherData === "string") {
            drawData = JSON.parse(item.OtherData);
            if (typeof drawData === "string") {
              drawData = JSON.parse(drawData);
            }
          } else {
            drawData = item.OtherData;
          }

          let startPoint = new THREE.Vector3(
            drawData.startPoint.x,
            drawData.startPoint.y,
            0
          );
          let endPoint = new THREE.Vector3(
            drawData.endPoint.x,
            drawData.endPoint.y,
            0
          );
          startPoint.add(vecMove);
          endPoint.add(vecMove);

          let OtherData = {
            startPoint: {
              x: startPoint.x,
              y: startPoint.y,
              z: 0,
            },
            endPoint: {
              x: endPoint.x,
              y: endPoint.y,
              z: 0,
            },
          };
          item.startPoint = startPoint;
          item.endPoint = endPoint;
          item.OtherData = OtherData;
          item.updateThisObj(item, true, vecMove);
        }
      }
    }

    //用途
    if (moveData["rlUse"]) {
      for (const item of moveData["rlUse"]) {
        item.saveEditRevokeData();

        let points = item.points;
        for (let i = 0; i < points.length; i++) {
          points[i].x += vecMove.x;
          points[i].y += vecMove.y;
        }
        item.points = points;
        item.updateThisObj(item);
      }
    }

    //悬挑板
    if (moveData["rlCantiSlab"]) {
      for (const item of moveData["rlCantiSlab"]) {
        item.saveEditRevokeData();
        if (copyRes && copyRes[item.m_gridData.Guid]) {
          item.m_gridData.m_cantiSlabId = null;
          item.m_gridData = copyRes[item.m_gridData.Guid];
        }
        item.updateThisObj(item);
      }
    }

    //板洞
    if (moveData["rlSlabHole"]) {
      for (const item of moveData["rlSlabHole"]) {
        item.saveEditRevokeData();
        if (copyRes && copyRes[item.m_JointData.Guid]) {
          item.m_JointData.m_slabHoleId = null;
          item.m_JointData = copyRes[item.m_JointData.Guid];
        }
        item.updateThisObj(item);
      }
    }

    if (errorData.length > 0) {
      Message.warning("移动后存在楼板不在闭合网格内，请注意检查！");
    }
    //移动完毕后才能删除
    Object.keys(newJointData).forEach((key) => {
      let jointObj = getEntityData({
        classTypeName: "rlJoint",
        Guid: key,
      });

      if (jointObj) {
        jointObj.erase();
      }
    });
  } catch (error) {
    console.error("移动实体失败", error);
  } finally {
    rlAppObj.rlMxDrawObject.updateDisplay();
    tryHideFullScreenLoading();
  }

  // await saveDatabaseStore();保存放在inputElement.js中
};
// 返回一个取点坐标
export const select_point = () => {
  return new Promise((resolve, reject) => {
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: true,
    });
    // 实例化取点对象
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    // 鼠标第一次点击
    getPoint.go((status) => {
      if (status == -1) {
        Message.closeAll();
        // 关闭弹窗
        store.commit("platBtns/CHANGE_MOVEBOX", {
          id: store.state.platBtns.topBtnActive.drawId,
          bol: false,
        });
      }
      window.canvas
        .getContext("2d")
        .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
      if (status != 0) {
        return;
      }
      // 当前鼠标位置
      let pt = getPoint.value();
      pt = enableSnapCorrection(pt);
      resolve(pt);
    });
  });
};

// 返回移动端取点坐标
export const mobile_select_point = () => {
  return new Promise((resolve, reject) => {
    // 实例化取点对象
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    // 鼠标第一次点击
    getPoint.go((status1) => {
      getPoint.go((status2) => {
        if (status1 == -1) {
          Message.closeAll();
          // 关闭弹窗
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status2 != 0) {
          store.commit("drawModules/setDrawPlay", false);
          return resolve();
        }
        // 当前鼠标位置
        let pt = getPoint.value();
        resolve(pt);
      });
    });
  });
};

//主动框选的移动--通过选择移动点移动
export const move_ents_byPoint = () => {
  return new Promise((resolve, reject) => {
    const move_fn = async (ids) => {
      if (!ids.length) return;
      //弹出移动信息框给用户输入，如果用户输入，则按输入执行，否则，继续提示用户选基点和移动点
      // store.commit('platBtns/SET_FIXATIONSHOW', true)
      //
      //选择基点
      Message && Message.closeAll();
      let messageObj = Message({
        duration: 0,
        message: "请选择基点",
        type: "info",
      });
      let sp = "";
      let ep = "";
      select_point().then((res) => {
        sp = res;
        messageObj.message = "请指定第二个位置";
        select_point().then((res2) => {
          //选择基点移动后的位置
          ep = res2;
          //计算偏移向量
          let vecMove = new THREE.Vector3(ep.x - sp.x, ep.y - sp.y, 0);

          // move_ents(ids, vecMove);
          moveCad(ids, vecMove);

          messageObj.close();
          rlAppObj.rlMxDrawObject.updateDisplay();
        });
      });
    };
    userSelect(move_fn)
      .then(async (ids) => {
        resolve("绘制结束");
      })
      .catch((err) => {
        reject();
      });
  });
};

//显示隐藏轴线轴号
export const show_hide_axis_no = async (current_sel_ent) => {
  let current_sel_axis = null;
  if (current_sel_ent.classTypeName == "rlAxis") {
    current_sel_axis = current_sel_ent;
  } else if (current_sel_ent.classTypeName == "rlGrid") {
    // current_sel_axis = await getGridAxisData(current_sel_ent);
    current_sel_axis = current_sel_ent.m_Axis;
  } else return;
  if (current_sel_axis) {
    const rlAxis = getEntityData({
      Guid: current_sel_axis.Guid,
      classTypeName: "rlAxis",
    });
    if (rlAxis) {
      rlAxis.saveEditRevokeData();
      rlAxis.isShow = rlAxis.isShow == "1" ? "0" : "1";
      rlAxis.showAxisName(rlAxis.isShow);
      rlAxis.updateThisObj(rlAxis);
      //将操作步骤下的所有数据更新到数据库中
      await saveDatabaseStore();
      toggleAxisDist(false);
      toggleAxisDist(true);
      rlAppObj.rlMxDrawObject.updateDisplay();
    }
  }
};

//通过输入偏移距离和角度移动
export const move_ents_byInput = async (dist, angle) => {
  userSelect().then((ids) => {
    if (!ids.length) return;
    //选择基点
    let sp = "";
    let ep = "";

    //选择基点
    Message && Message.closeAll();
    let messageObj = Message({
      duration: 0,
      message: "请选择基点",
      type: "info",
    });

    select_point().then((res) => {
      sp = res;
      //计算移动点
      let angleRadians = angle * (Math.PI / 180);
      let move_x = dist * Math.cos(angleRadians);
      let move_y = dist * Math.sin(angleRadians);
      let ptMove = new THREE.Vector3(sp.x + move_x, sp.y + move_y, sp.z);
      let vecMove = new THREE.Vector3(ptMove.x - sp.x, ptMove.y - sp.y, 0);
      // move_ents(ids, vecMove);
      moveCad(ids, vecMove);
    });
    messageObj.close();
  });
  rlAppObj.rlMxDrawObject.updateDisplay();
};

// 镜像操作
export const mirror_entiy = async (topBtnActive, currentEnt, context) => {
  if (topBtnActive && topBtnActive.id == 406) {
  }
};
//通过坐标计算选中的构件的边
const getModelLineByPoint = (point, modelObj, baseLine = null) => {
  if (modelObj && point) {
    //获取构件的边数据
    let polylineObj = modelObj.mcDbId?.getMcDbEntity();
    if (polylineObj) {
      let number = polylineObj.numVerts();
      for (let i = 0; i < number; i++) {
        let stIndex = i;
        let edIndex = i == number - 1 ? 0 : i + 1;

        let mcPoint1 = polylineObj.getPointAt(stIndex).val;
        let mcPoint2 = polylineObj.getPointAt(edIndex).val;
        let pt1 = new THREE.Vector3(mcPoint1.x, mcPoint1.y, mcPoint1.z);
        let pt2 = new THREE.Vector3(mcPoint2.x, mcPoint2.y, mcPoint2.z);
        //太靠近端点的位置不取，避免判断不准确
        if (pt1.distanceTo(point) < 5 || pt2.distanceTo(point) < 5) {
          return null;
        }

        if (baseLine) {
          //判断是否与baseLine平行
          // 计算线段的方向向量
          const lineVec = new THREE.Vector3().subVectors(pt1, pt2);
          const beseVec = new THREE.Vector3().subVectors(
            baseLine.start,
            baseLine.end
          );

          const slope1 =
            Math.abs(lineVec.x) < Math.exp(-1) ? 9999 : lineVec.y / lineVec.x;
          const slope2 =
            Math.abs(beseVec.x) < Math.exp(-1) ? 9999 : beseVec.y / beseVec.x;

          //两线段斜率相等，则平行,否则，不平行
          if (Math.abs(slope1 - slope2) > Math.exp(-2)) continue;
        }

        let line = new THREE.Line3(pt1, pt2);
        let ptClosest = line.closestPointToPoint(point);
        let distance = ptClosest.distanceTo(point);
        if (distance < 50) {
          return line;
        }
      }
    }
  }
  return null;
};
//实体对齐
export const moveModel_entity = async () => {
  //获取选中的构件
  const getSelectModelData_1 = async (baseModelObj = null, baseLine = null) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    return new Promise((resolve, reject) => {
      getPoint.go((status) => {
        if (status === 0) {
          let ptInput = getPoint.value();

          let viewCoord = rlAppObj.rlMxDrawObject.getViewDocCoord();
          // 根据视区范围调整文本大小
          let viewWidth = Math.abs(viewCoord.pt3.x - viewCoord.pt1.x);
          viewWidth = viewWidth <= 400 ? 400 : viewWidth;

          let maxDist = viewWidth / 80;

          //获取轴线
          if (baseLine == null) {
            let axisData = store.state.rlEntData.totalEntityData["rlAxis"];
            for (const axis of axisData) {
              let point1 = new THREE.Vector3(...axis.m_stJoint.m_pt);
              let point2 = new THREE.Vector3(...axis.m_edJoint.m_pt);
              let line = new THREE.Line3(point1, point2);
              let ptClosest = line.closestPointToPoint(ptInput);
              let distance = ptClosest.distanceTo(ptInput);
              if (distance < maxDist) {
                baseLine = line;
                baseModelObj = axis;
                resolve({ selectObj: axis, selectLine: line });
              }
            }
          }

          let rlColumnGroup = store.state.rlEntData.totalEntityData["rlColSeg"];
          let rlBeamGroup = store.state.rlEntData.totalEntityData["rlBeamSeg"];
          let rlWallGroup = store.state.rlEntData.totalEntityData["rlWallSeg"];
          let rlPartitionWallGroup =
            store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
          let totalModelData = [
            ...rlColumnGroup,
            ...rlBeamGroup,
            ...rlWallGroup,
            ...rlPartitionWallGroup,
          ];
          let selectModelData = null;
          maxDist = viewWidth / 50;
          //获取构件的边
          for (const modelObj of totalModelData) {
            if (baseModelObj && modelObj.Guid == baseModelObj.Guid) continue;
            if (!modelObj.mcDbId.getMcDbEntity().visible) continue;
            let polyObj = modelObj.mcDbId.getMcDbEntity();
            let number = polyObj.numVerts();
            let vertices = [];
            for (let j = 0; j < number + 1; j++) {
              let pt = polyObj.getPointAt(j).val;
              vertices.push(new THREE.Vector3(pt.x, pt.y, pt.z));
              let point1 = null;
              let point2 = null;
              if (j == number) {
                point1 = vertices[j - 1];
                point2 = vertices[0];
              } else if (j > 0) {
                point1 = vertices[j - 1];
                point2 = vertices[j];
              }

              if (point1 && point2) {
                if (baseLine) {
                  //判断是否与baseLine平行
                  // 计算线段的方向向量
                  const lineVec = new THREE.Vector3().subVectors(
                    point1,
                    point2
                  );
                  const beseVec = new THREE.Vector3().subVectors(
                    baseLine.start,
                    baseLine.end
                  );

                  const slope1 =
                    Math.abs(lineVec.x) < Math.exp(-1)
                      ? 9999
                      : lineVec.y / lineVec.x;
                  const slope2 =
                    Math.abs(beseVec.x) < Math.exp(-1)
                      ? 9999
                      : beseVec.y / beseVec.x;

                  //两线段斜率相等，则平行,否则，不平行
                  if (Math.abs(slope1 - slope2) > Math.exp(-2)) continue;
                }
                //计算点与线段的距离
                let line = new THREE.Line3(point1, point2);
                let ptClosest = line.closestPointToPoint(ptInput);
                let distance = ptClosest.distanceTo(ptInput);

                if (
                  distance < maxDist &&
                  ptOnLine(point1, point2, ptClosest) > 0
                ) {
                  selectModelData = {
                    selectObj: modelObj,
                    selectLine: new THREE.Line3(point1, point2),
                  };
                  resolve(selectModelData);
                }
              }
            }
          }

          resolve(selectModelData);
        }
      });
    });
  };
  //获取选中的构件
  const getSelectModelData = async (baseLine = null) => {
    const filter = new MxCADResbuf();
    filter.AddMcDbEntityTypes("LWPOLYLINE");

    return new Promise((resolve, reject) => {
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();

      const selectEntity = () => {
        getPoint.go((status) => {
          if (status === 0) {
            let pt = getPoint.value();

            let selectEntId = MxCADUtility.findEntAtPoint(
              pt.x,
              pt.y,
              pt.z,
              -1,
              filter
            );
            if (selectEntId) {
              MxCADUtility.highlightEntity(selectEntId.id, true);
              let modelObj = getEntityById(selectEntId); //获取基准构件对象

              if (modelObj && modelObj.ModelType) {
                let line = getModelLineByPoint(pt, modelObj, baseLine); // 获取构件的边
                if (line) resolve({ selectObj: modelObj, selectLine: line });
                else {
                  Message.warning("请选择有效的构件边");
                  selectEntity(); // 继续选择
                }
              } else {
                Message.warning("请选择有效的构件");
                selectEntity(); // 继续选择
              }
            } else {
              Message.warning("未找到构件，请重新选择");
              selectEntity(); // 继续选择
            }
          } else {
            reject("用户取消选择" + status);
            return false;
          }
        });
      };

      selectEntity(); // 开始选择
    });
  };

  try {
    let msgInstance = Message.info("请选择基准构件的边");
    let baseModelSelectData = await getSelectModelData_1(); // 等待用户选择
    if (baseModelSelectData) {
      let baseModelObj = baseModelSelectData.selectObj; //基准构件
      let baseModelLine = baseModelSelectData.selectLine; //基准线

      msgInstance.close();
      // 可以在此处调用 getModelLineByPoint(baseModelObj) 等后续处理
      msgInstance = Message.info("请选择移动对齐构件的边");
      let moveModeSelectObj = await getSelectModelData_1(
        baseModelObj,
        baseModelLine
      );
      msgInstance.close();
      if (moveModeSelectObj) {
        store.commit("globalData/setCanAddRawStep", true);
        let moveModelObj = moveModeSelectObj.selectObj; //移动对齐构件
        let moveModelLine = moveModeSelectObj.selectLine; //移动对齐线

        // 可以在此处调用 getModelLineByPoint(moveModelObj) 等后续处理
        // 计算移动对齐构件的边与基准构件的边的偏移量

        let ptClosest = baseModelLine.closestPointToPoint(moveModelLine.start);
        let offset = new THREE.Vector3().subVectors(
          ptClosest,
          moveModelLine.start
        );
        // offset.subVectors(baseModelLine.start, moveModelLine.start);
        // offset.add(moveModelLine.end);

        // 移动对齐构件
        moveModelObj.saveEditRevokeData();
        moveModelObj.transformBy(offset);
        moveModelObj.updateThisObj(moveModelObj);
        saveDatabaseStore();
        // await moveModelObj.updateThisObj(moveModelObj);
        Message.success("对齐成功");
      }
    }
  } catch (error) {
    Message.warning(`操作失败: ${error}`);
    console.error("操作失败", error);
    return false;
  }
};

//实体批量对齐
let AlignBaseLine; //基准边--对齐
let AlignAllIds = []; //所选id--对齐
let AlignSelLineIds = []; //选中的轮廓--对齐
export const moveModel_entity_batch = async () => {
  //用户选择基准边
  const getBaseLine = async () => {
    let msgInstance = Message.info("请选择基准构件的边");
    return new Promise((resolve, reject) => {
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      getPoint.setInputToucheType(1);
      getPoint.go(async (status1) => {
        if (status1 == 0) {
          let filter = "LWPOLYLINE";
          const findFilter = new MxCADResbuf();
          findFilter.AddMcDbEntityTypes(filter);

          const ptInput = getPoint.value();
          let viewCoord = rlAppObj.rlMxDrawObject.getViewDocCoord();
          // 根据视区范围调整文本大小
          let viewWidth = Math.abs(viewCoord.pt3.x - viewCoord.pt1.x);
          viewWidth = viewWidth <= 400 ? 400 : viewWidth;
          let maxDist = store.state.globalData.isMobile
            ? viewWidth / 80
            : viewWidth / 200;

          let closestLine = null;
          //获取轴线
          let gridData = store.state.rlEntData.totalEntityData["rlGrid"];
          for (const grid of gridData) {
            let point1 = new THREE.Vector3(...grid.m_stJoint.m_pt);
            let point2 = new THREE.Vector3(...grid.m_edJoint.m_pt);
            let line = new THREE.Line3(point1, point2);
            let ptClosest = line.closestPointToPoint(ptInput);
            let distance = ptClosest.distanceTo(ptInput);
            if (distance < maxDist) {
              closestLine = line;
              maxDist = distance;
              // resolve(line);
              // msgInstance.close(); //删除提示
              // return;
            }
          }
          if (closestLine) {
            resolve(closestLine);
            msgInstance.close(); //删除提示
            return;
          }

          let rlColumnGroup = store.state.rlEntData.totalEntityData["rlColSeg"];
          let rlBeamGroup = store.state.rlEntData.totalEntityData["rlBeamSeg"];
          let rlWallGroup = store.state.rlEntData.totalEntityData["rlWallSeg"];
          let rlPartitionWallGroup =
            store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
          let totalModelData = [
            ...rlColumnGroup,
            ...rlBeamGroup,
            ...rlWallGroup,
            ...rlPartitionWallGroup,
          ];
          maxDist = viewWidth / 50;
          //获取构件的边
          for (const modelObj of totalModelData) {
            if (!modelObj.mcDbId.getMcDbEntity().visible) continue;
            const polyObj = modelObj.mcDbId.getMcDbEntity().clone();
            let number = polyObj.numVerts();
            let vertices = [];
            for (let j = 0; j < number + 1; j++) {
              let pt = polyObj.getPointAt(j).val;
              vertices.push(new THREE.Vector3(pt.x, pt.y, pt.z));
              let point1 = null;
              let point2 = null;
              if (j == number) {
                point1 = vertices[j - 1];
                point2 = vertices[0];
              } else if (j > 0) {
                point1 = vertices[j - 1];
                point2 = vertices[j];
              }

              if (point1 && point2) {
                //计算点与线段的距离
                let line = new THREE.Line3(point1, point2);
                let ptClosest = line.closestPointToPoint(ptInput);
                let distance = ptClosest.distanceTo(ptInput);

                if (
                  distance < maxDist &&
                  ptOnLine(point1, point2, ptClosest) > 0
                ) {
                  closestLine = line;
                  maxDist = distance;
                  // resolve(new THREE.Line3(point1, point2));
                  // msgInstance.close(); //删除提示
                  // return;
                }
              }
            }
          }
          if (closestLine) {
            resolve(closestLine);
            msgInstance.close(); //删除提示
            return;
          }
          msgInstance.close(); //删除提示
          resolve(null);
        }
      });
    });
  };
  //用户选择移动对齐构件
  const MoveModelEntity = async (line) => {
    AlignBaseLine = line;
    // 添加合并拆分按钮点击事件监听
    window.addEventListener(
      "mergeSplitButtonClick",
      handleMergeSplitButtonClick
    );

    let isY = isParallel(
      line.start,
      line.end,
      new McGePoint3d(10, 0, 0),
      new McGePoint3d(-10, 0, 0)
    );
    if (isY) createMergeSplitButton("↑", "↓");
    else createMergeSplitButton("←", "→");

    let msgInstance = Message.info("请选择需要移动的构件");

    const moveEnts = async (ids) => {
      if (!ids || !ids.length) return;
      for (const id of ids) {
        let modelObj = getEntityById(id);
        if (
          modelObj &&
          modelObj.classTypeName &&
          (modelObj.classTypeName == "rlColSeg" ||
            modelObj.classTypeName == "rlBeamSeg" ||
            modelObj.classTypeName == "rlWallSeg" ||
            modelObj.classTypeName == "rlPartitionWallSeg")
        ) {
          const delLine = AlignSelLineIds.find(
            (L) => L.EntGuid == modelObj.Guid
          );
          if (!delLine) {
            // 绘制新的多段线
            const newLine = modelObj.mcDbPolyline.clone();
            newLine.drawOrder = 999999;
            newLine.trueColor = new McCmColor(242, 255, 0);
            newLine.setxDataString("Guid", "");
            newLine.setxDataString("classTypeName", "");
            const LineId = await rlAppObj.mxcadObject.drawEntity(newLine);
            // 添加到多段线数组
            AlignSelLineIds.push({
              EntGuid: modelObj.Guid,
              lineId: LineId,
            });
            AlignAllIds.push(id);
          } else {
            // const delLine = AlignSelLineIds.find((L) => L.EntGuid == modelObj.Guid);
            const delId = AlignAllIds.find((L) => L == id);
            if (delLine && delLine.lineId) {
              delLine.lineId.getMcDbEntity().erase();
              AlignSelLineIds.splice(AlignSelLineIds.indexOf(delLine), 1);
            }
            AlignAllIds.splice(AlignAllIds.indexOf(delId), 1);
          }
        }
      }
    };
    userSelect(moveEnts);
  };

  //获取用户选择的基准边，若没有选择，继续选择
  const getUserSelectBaseLine = async () => {
    getBaseLine().then(async (line) => {
      if (line) {
        //绘制一条基准线
        let lineEntity = new McDbLine();
        const vecDir = new THREE.Vector3();
        line.delta(vecDir);
        vecDir.normalize();

        lineEntity.startPoint = new McGePoint3d(
          line.start.x - vecDir.x * 50000,
          line.start.y - vecDir.y * 50000,
          line.start.z
        );
        lineEntity.endPoint = new McGePoint3d(
          line.end.x + vecDir.x * 50000,
          line.end.y + vecDir.y * 50000,
          line.end.z
        );

        //绿色
        lineEntity.trueColor = new McCmColor(0, 255, 0);
        let lineId = rlAppObj.mxcadObject.drawEntity(lineEntity);
        store.commit("globalData/setBaseLineId", lineId);
        await MoveModelEntity(line);

        lineEntity.erase();
        return;
      } else {
        return getUserSelectBaseLine();
      }
    });
  };
  getUserSelectBaseLine();
};
//批量对齐移动
const moveAllEnt = async (isLeft) => {
  let ids = AlignAllIds;
  let line = AlignBaseLine;
  if (ids.length == 0) return;
  try {
    showFullScreenLoading("正在处理对齐..");
    // 确保 showFullScreenLoading 执行完毕
    await new Promise((resolve) => setTimeout(resolve, 50));

    const beseVec = new THREE.Vector3().subVectors(line.start, line.end);
    const slope =
      Math.abs(beseVec.x) < Math.exp(-1) ? 9999 : beseVec.y / beseVec.x;
    // 提交一个全局的操作步骤
    store.commit("globalData/setCanAddRawStep", true);
    let jointData = store.state.rlEntData.totalEntityData["rlJoint"];
    let gridData = store.state.rlEntData.totalEntityData["rlGrid"];
    for (const id of ids) {
      let modelObj = getEntityById(id);
      if (
        modelObj &&
        modelObj.classTypeName &&
        (modelObj.classTypeName == "rlColSeg" ||
          modelObj.classTypeName == "rlBeamSeg" ||
          modelObj.classTypeName == "rlWallSeg" ||
          modelObj.classTypeName == "rlPartitionWallSeg")
      ) {
        let isCol = modelObj.classTypeName == "rlColSeg";
        let isWall = modelObj.classTypeName == "rlWallSeg";
        let isPartitionWall = modelObj.classTypeName == "rlPartitionWallSeg";
        let polylineObj = modelObj.mcDbId?.getMcDbEntity().clone();
        if (!isCol && modelObj.m_gridData && modelObj.Ecc) {
          //将墙梁构件先回到初始位置再计算
          modelObj.Ecc = 0;
          modelObj.updateThisObj(modelObj);
          polylineObj = modelObj.mcDbId?.getMcDbEntity().clone();
          // let stPoint = new THREE.Vector3(...modelObj.m_gridData.m_stJoint.m_pt);
          // let edPoint = new THREE.Vector3(...modelObj.m_gridData.m_edJoint.m_pt);
          // let gridVec = new THREE.Vector3().subVectors(stPoint, edPoint);
          // let gridVecPrep = new THREE.Vector3();
          // gridVecPrep.crossVectors(gridVec, new THREE.Vector3(0, 0, 1));
          // gridVecPrep.normalize();
          // let matrix = new McGeMatrix3d();
          // matrix.setToTranslation(
          //   new McGeVector3d(
          //     -gridVecPrep.x * modelObj.Ecc,
          //     -gridVecPrep.y * modelObj.Ecc,
          //     0
          //   )
          // ); //平移
          // polylineObj.transformBy(matrix);
        }
        let minDist = 1000;
        let closestLineData = [];
        let moveVec1 = new THREE.Vector3();
        let moveVec2 = new THREE.Vector3();
        let dist1 = 1000000;
        let dist2 = 1000000;
        let isMove = false;
        if (polylineObj) {
          let number = polylineObj.numVerts();
          for (let i = 0; i < number; i++) {
            let stIndex = i;
            let edIndex = i == number - 1 ? 0 : i + 1;

            let mcPoint1 = polylineObj.getPointAt(stIndex).val;
            let mcPoint2 = polylineObj.getPointAt(edIndex).val;
            let pt1 = new THREE.Vector3(mcPoint1.x, mcPoint1.y, mcPoint1.z);
            let pt2 = new THREE.Vector3(mcPoint2.x, mcPoint2.y, mcPoint2.z);
            let lineTmp = new THREE.Line3(pt1, pt2);
            //判断lineTmp是否与line平行
            const lineVec = new THREE.Vector3().subVectors(pt1, pt2);

            const slope1 =
              Math.abs(lineVec.x) < Math.exp(-1) ? 9999 : lineVec.y / lineVec.x;

            if (Math.abs(slope1 - slope) > Math.exp(-2)) continue;

            let ptClosest = lineTmp.closestPointToPoint(line.start);
            let distance = ptClosest.distanceTo(line.start);
            if (distance < 1000) {
              let vecTmp = new THREE.Vector3().subVectors(
                line.start,
                ptClosest
              );
              vecTmp.normalize();
              if (Math.abs(vecTmp.x) < 0.001 && Math.abs(vecTmp.y) < 0.001) {
                continue; //无效向量
              }
              if (isEmpty(closestLineData)) {
                closestLineData.push({
                  vec: vecTmp,
                  distance,
                  vecMove: new THREE.Vector3().subVectors(
                    line.start,
                    ptClosest
                  ),
                });
              } else {
                const matchData = closestLineData.find(
                  (item) =>
                    Math.abs(item.vec.x - vecTmp.x) < 0.001 &&
                    Math.abs(item.vec.y - vecTmp.y) < 0.001
                );
                if (matchData && matchData.distance > distance) {
                  matchData.vec = vecTmp;
                  matchData.distance = distance;
                  matchData.vecMove = new THREE.Vector3().subVectors(
                    line.start,
                    ptClosest
                  );
                } else if (!matchData || matchData.length == 0) {
                  closestLineData.push({
                    vec: vecTmp,
                    distance,
                    vecMove: new THREE.Vector3().subVectors(
                      line.start,
                      ptClosest
                    ),
                  });
                }
              }
            }

            if (distance <= minDist + 10) {
              if (moveVec1.length() > 0) {
                moveVec2 = new THREE.Vector3().subVectors(
                  line.start,
                  ptClosest
                );
                dist2 = distance;
              } else {
                moveVec1 = new THREE.Vector3().subVectors(
                  line.start,
                  ptClosest
                );
                dist1 = distance;
              }
              minDist = distance;
              isMove = true;
            }
          }
        }

        console.log("closestLineData", closestLineData);

        let isMatch = false;
        if (isMove) {
          //判断构件能移动的方向
          let moveVec = new THREE.Vector3();
          if (isLeft) {
            if (closestLineData.length > 0) {
              let matchVec = closestLineData.filter(
                (item) =>
                  (item.vec.x < 0 && item.vec.y > 0) || //右上->左下的斜线
                  (item.vec.x > 0 && item.vec.y > 0) || //左上->右下的斜线
                  (Math.abs(item.vec.x) < 0.001 && item.vec.y >= 0) ||
                  (Math.abs(item.vec.y) < 0.001 && item.vec.x <= 0)
              );
              if (matchVec.length > 0) {
                moveVec = matchVec[0].vecMove;
                isMatch = true;
              }
            }
            // if (moveVec.length() == 0) {
            //   if (isCol || isWall || isPartitionWall) moveVec = moveVec1;
            //   else moveVec = moveVec2;
            // }
          } else {
            if (closestLineData.length > 0) {
              let matchVec = closestLineData.filter(
                (item) =>
                  (item.vec.x > 0 && item.vec.y < 0) || //右上->左下的斜线
                  (item.vec.x < 0 && item.vec.y < 0) || //左上->右下的斜线
                  (Math.abs(item.vec.x) < 0.001 && item.vec.y < 0) ||
                  (Math.abs(item.vec.y) < 0.001 && item.vec.x >= 0)
              );
              if (matchVec.length > 0) {
                moveVec = matchVec[0].vecMove;
                isMatch = true;
              }
            }
            // if (moveVec.length() == 0) {
            //   if (isCol || isWall || isPartitionWall) moveVec = moveVec2;
            //   else moveVec = moveVec1;
            // }
          }
          if (!isCol && !isMatch) {
            let ptGridSt = new McGePoint3d(
              ...modelObj.m_gridData.m_stJoint.m_pt
            );
            let ptGridEd = new McGePoint3d(
              ...modelObj.m_gridData.m_edJoint.m_pt
            );
            let isY = isParallel(
              ptGridSt,
              ptGridEd,
              new McGePoint3d(0, 10, 0),
              new McGePoint3d(0, -10, 0)
            );

            if (isY) {
              if (ptGridSt.y < ptGridEd.y)
                moveVec = new THREE.Vector3(-moveVec.x, -moveVec.y, -moveVec.z);
            } else {
              if (ptGridSt.x < ptGridEd.x)
                moveVec = new THREE.Vector3(-moveVec.x, -moveVec.y, -moveVec.z);
            }
          }
          console.log("moveVec", moveVec);

          if (moveVec.length() > 0) {
            modelObj.saveEditRevokeData();
            if (modelObj.Ecc) modelObj.Ecc = 0;

            // moveVec.x += modelObj.Ecc;
            // moveVec.y += modelObj.Ecc;
            modelObj.transformBy(moveVec);
            modelObj.updateThisObj(modelObj);
          }
        }
      }
    }
    await saveDatabaseStore();
    AlignAllIds = [];
    removeAllSelLineIds();
    tryHideFullScreenLoading();
  } catch {
    AlignAllIds = [];
    removeAllSelLineIds();
    tryHideFullScreenLoading();
  }
};

// 处理移动方向按钮点击
const handleMergeSplitButtonClick = async (event) => {
  const { type, name } = event.detail;
  // 取消
  if (type === "cancel") {
    deleteBaseLine();
  }
  // 左
  if (type === "merge") {
    if (name === "←" || name === "↑") {
      // 递归
      await moveAllEnt(true);
    }
  }
  // 右
  if (type === "split") {
    if (name === "→" || name === "↓") {
      await moveAllEnt(false);
    }
  }
};

//删除批量对齐选中的构件绘制的轮廓线
const removeAllSelLineIds = async () => {
  for (const delLine of AlignSelLineIds) {
    if (delLine && delLine.lineId) {
      delLine.lineId.getMcDbEntity().erase();
    }
  }
  AlignSelLineIds = [];
};

//删除批量对齐的基准线
export const deleteBaseLine = () => {
  // 移除事件监听
  window.removeEventListener(
    "mergeSplitButtonClick",
    handleMergeSplitButtonClick
  );
  removeAllSelLineIds();
  destroyMergeSplitButton();
  let lineId = store.state.globalData.baseLineId;
  if (lineId) {
    let lineEntity = lineId.getMcDbEntity();
    lineEntity.erase();
    store.commit("globalData/setBaseLineId", null);
  }
};

const getEntByPoint = () => {
  let pt = rlAppObj._rlMx.MxFun.getCurrentMousePostion();

  return new Promise((resolve, reject) => {
    let idToData = {};
    let filter = "LWPOLYLINE";
    rlAppObj._rlMx.MrxDbgUtils.findEntAtPoint(
      pt,
      undefined,
      undefined,
      false,
      (id, data) => {
        // 得到点击位置的扩展数据.
        idToData[id] = data;
      }
    ).then((aryId) => {
      // 得到点击的对象.
      let currentEnt = rlAppObj.rlMxDrawObject.getMxEntity(aryId[0]);

      pt = rlAppObj._rlMx.MxFun.screenCoord2World(pt.x, pt.y, pt.z);
      resolve({ pt: pt, currentEnt: currentEnt });
    });
  });
};

//仅供测试
export const testFun = () => {
  // 获取当前MxCAD实例
  const mxcad = MxCpp.getCurrentMxCAD();

  // 保存文件到URL
  mxcad.saveFileToUrl(
    "1", // 保存文件的目标URL
    (iResult, sserverResult) => {
      // 处理服务器返回结果
      try {
        const ret = JSON.parse(sserverResult);
        if (ret.ret === "ok") {
          console.log("文件保存成功:", ret.file);
        } else {
          console.error("文件保存失败:", ret);
        }
      } catch (error) {
        console.error("解析服务器响应失败:", error);
      }
    },
    "myDrawing.dwg", // 可选: 指定保存的文件名
    {
      /* 可选: 额外参数 */
    }
  );
};
